import React, { useEffect, useRef, useState, useCallback } from "react";
import { useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import ReactFlow, {
    addEdge,
    MarkerType,
    updateEdge,
    Icons,
    applyNodeChanges,
    applyEdgeChanges,
} from '@uniphore/react-flow';
import '@uniphore/react-flow/dist/index.css'
import { INodesContext } from "@uniphore/react-flow/dist/types/A8FlowRenderer/Context";
import dagre from 'dagre';
import _ from "lodash";
import { uuid } from "../../../../../helpers/commonFunction/uuid";
import { pushToast } from '../../../../../stateManager/store/toast/actions';
import { Http } from "../../../../../helpers/axois";
import style from "../solo.module.sass";
import WarningSvg from '../../../../../assets/svg/solo/bxs-error.svg';
import layoutIcon from '../../../../../assets/svg/solo/flow_layout_ico.svg'
import { AppState } from "../../../../../stateManager/store";
import { SAVE_SOLO } from '../../../../../stateManager/store/solo/types';
import WidgetIconsView from "./WidgetIconsView";
import './flow.css';
import { Button } from "antd";
import WidgetListView from "./WidgetListView";
import Properties from "../properties";
import IssuesSvg from '../../../../../assets/svg/solo/alert.svg';
import { soloSaveSuccess, findSourceConnection, selectedServices, ModalSelectedValue, GoBackFunctionality, selectedSolo as soloWindow  } from "../../../../../stateManager/store/solo/action"
import { useToast } from "../../../../../helpers/commonFunction";
import { FormModal } from '../../../Assisted/assistJourney/create/BpmnProperties/FormModal'
import { ServiceModal } from "../../../Assisted/assistJourney/create/BpmnProperties/serviceModal"
import {ResourceLock} from "../../../../../helpers/RxServices";
import {onBpmnAction} from "../../../../../stateManager/store/common/action";
import { AgentListModal } from "../../../common/agentModal";
import ActionModal, { ActionList } from "../../../common/actionModal";
import { useSoloJourneyContext } from "./SoloJourneyProvider";
interface Iprops {
    match: any;
    history: any;
    appVersion?: { currentVersion: boolean, versionId: string };
}

export type ActionDetails = ActionList

interface Istate {
    formKey: string,
    position: {
        x: number,
        y: number
    }
}
const initialElements = [{
    id: '_soloStartNode',
    type: Icons[0].type,
    data: Icons[0],
    position: { x: 250, y: 5 }
}];

const Solo = () => {/* eslint-disable */
    const params: any = useParams();
    const dispatch = useDispatch();
    const [authFlow, setAuthFlow]: any = useState(null);
    const { appId, soloId } = params;
    const [flowDetail, setFlowDetail]: any = useState(null);
    const [newNodeDetail, setNewNodeDetail]: any = useState(null);
    const [openIssues, setOpenIssues]: any = useState(false);
    const [propertiesDetail, setProperties]: any = useState(null);
    const [issueDetails, setIssueDetails]: any = useState(null);
    const reactFlowWrapper: any = useRef(null);
    const edgeUpdateSuccessful = useRef(true);
    const [reactFlowInstance, setReactFlowInstance]: any = useState(null);
    const [nodes, setNodes]: any = useState(initialElements)
    const [edges, setEdges]: any = useState([])
    const [elements, setElements]: any = useState(initialElements);
    const { isSaved } = useSelector((state: any) => state.solo);
    const appversion: { currentVersion: boolean, versionId: string } = useSelector((state: any) => state.apps.appVersion[appId]);
    const selectedBranch = useSelector((state: AppState) => state.apps.appBranch);
    const branchId = selectedBranch && selectedBranch[appId] && selectedBranch[appId].branchId;
    const [draggedFrom, setDraggedFrom]: any = useState(null)
    const [dragVisible, setDragVisible] = useState(false)
    const [dragCoordinates, setDragCoordinates] = useState<{ x: number, y: number }>({ x: 0, y: 0 })
    const [forms, setForms]: any = useState(null)
    const [nameCheck, setNameCheck] = useState(false)
    const [widgetDrawer, setWidgetDrawer]: any = useState(false);
    const [soloDetails, setSoloDetails]: any = useState(null)
    const [saveSucces, setSaveSuccess]: any = useState(false)
    const [soloServices, setSoloServices]: any = useState(null);
    const [soloBuildInServices, setSoloBuildinServices]: any = useState(null)
    const [nodePosition, setNodePostion]: any = useState(null)
    const [checkElementsChanges, setCheckElementsChanges] = useState<any[]>([]);
    const { WarningToast, SuccessToast, ErrorToast } = useToast()
    const [visible, setVisible] = useState<boolean>(false);
    const [serviceVisible, setServiceVisible] = useState<boolean>(false);
    const [formkey, setFormKey]: any = useState(null)
    const [serviceKey, setServiceKey]: any = useState(null)
    const [selectedNodeId, setSelectedNodeId]: any = useState(null)
    const [selectedAuthFlow, setSeletedAuthFlow]: any = useState(null)
    const [backFunctionality, setBackFunctionality] = useState<Boolean>(false)
    const appVersion = useSelector((state: AppState) => state.apps.appVersion && state.apps.appVersion[appId]);
    const reactFlowRef: any = useRef(null);
    const [resourceLock, setResourceLock] = useState<any>({})
    const [showAllNodes, setShowAllNodes]: any = useState(true)
    const selectedSolo = useSelector((state: any) => state.solo.selectedSolo);
    const [nodesContext, setNodesContext] = useState<INodesContext>({
        lock: false,
        connectable: false,
        eventNodeServiceConnections: [],
        returningSubflows: []
    })
    const [showAgentModal, setShowAgentModal] = useState<boolean>(false)
    const [showActionModal, setShowActionModal] = useState<boolean>(false)
    const [agentDetails, setAgentDetails] = useState<{ isExternalAgent?: boolean, key: string, id: string, inputVariable: string[], outputVariable: any[], agentSelect : boolean}>({key: "", id: "", inputVariable: [], outputVariable: [], agentSelect: false})
    const [actionDetails, setActionDetails] = useState<Partial<ActionDetails>>({})
    const { selectedOrg } = useSelector((state: AppState) => state.org)
    const { setActionNodeProperties } = useSoloJourneyContext();
 
    const { lock, eventNodeServiceConnections, returningSubflows } = nodesContext


    function updateNodesContext(key: keyof INodesContext, value: boolean | string[]) {
        setNodesContext(prev => ({...prev, [key]: value}))
    }


    const currentAppversion = useSelector((state: any) => {
        return state.apps.appVersion && state.apps.appVersion[appId]
    })

    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
      })
    const isCheckedIn: boolean = resourceLock?.userId === loggedInUserId
    
    const appPermissions: any = useSelector((state: any) => {
        return state.apps.selectedApp.permissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const orgPermissions: any = useSelector((state: AppState) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const canEditSolo = orgPermissions.includes("bpmn.Edit") && appPermissions.includes('bpmn.Edit')
    
    const bpmnActionType = useSelector((state: any) => state.common.bpmnActionType)



    useEffect(() => {
        if (bpmnActionType === "SAVE") {
            onSave(nodes.concat(edges), false)
        } else if (bpmnActionType === "COMMIT") {
            onSave(nodes.concat(edges), true)
        } else if (bpmnActionType === "DISCARD") {
            onSave(nodes.concat(edges), true, true)
        }
        dispatch(onBpmnAction(null));
    }, [bpmnActionType])
    
    useEffect(() => {
        if (canEditSolo === false && isCheckedIn === false) {
            updateNodesContext('lock', true)
            setSaveSuccess(true)
        } else {
            updateNodesContext('lock', false)
            setSaveSuccess(false)
        }
        // getFlowDetails();
    }, [canEditSolo, isCheckedIn])

    useEffect(() => {
        if (currentAppversion && currentAppversion.currentVersion === true && canEditSolo && isCheckedIn) {
            updateNodesContext('lock', false)
        } else {
            updateNodesContext('lock', true)
        }
    }, [currentAppversion, isCheckedIn])

    useEffect(() => {
        if (reactFlowRef && reactFlowRef.current) {
            const edgeElement = reactFlowRef.current.querySelectorAll('.react-flow .react-flow__renderer svg defs #react-flow__arrowclosed');
            if (edgeElement && edgeElement.length > 0) {
                edgeElement[0].setAttribute("markerWidth", "20");
                edgeElement[0].setAttribute("markerHeight", "20");
            }
        }
    }, [reactFlowRef, reactFlowRef.current])

    useEffect(() => {
        if (isSaved) {
            onSave(nodes.concat(edges), false)
            dispatch({
                type: SAVE_SOLO,
                data: false
            });
        }
    }, [isSaved])

    useEffect(() => {
        dispatch(soloSaveSuccess(saveSucces))
    }, [saveSucces])

    useEffect(() => {
        dispatch(GoBackFunctionality(backFunctionality))
    }, [backFunctionality])

    useEffect(() => {
        let removePopertiesDetails = true;

        const elements = nodes.concat(edges)
        if (elements.length > 1) {
            const filteredElements = elements.map((el: any) => {
                if (el.type === "start") return null
                if (el.markerEnd) {
                    const { data, type, animated, ...others } = el
                    return others;
                }

                if (propertiesDetail && el.id === propertiesDetail.nodeDetail.id) {
                    removePopertiesDetails = false;
                }

                const { data, position } = el;
                const { height, width, selected, ...element } = el
                const { source, ...other } = position;
                const { lock, id, onRemoveNode, connect, elements, removedEdgeforLinkNode, edgeforLinkNode, nextNodes, ...others } = data;
                return {
                    ...element,
                    data: others,
                    position: other
                }
            }).filter((el: any) => el)
            const filteredCheckElements = checkElementsChanges && checkElementsChanges.filter((e: any) => { return e.type !== "start" })
            const checkElement = filteredCheckElements.map((el: any) => {
                //if (el.type === "start") return null
                if (el.markerEnd) {
                    const { data, type, animated, ...others } = el
                    return others;
                }
                const { data, position } = el;
                const { height, width, selected, ...element } = el
                const { lock, id, onRemoveNode, connect, elements, removedEdgeforLinkNode, edgeforLinkNode, nextNodes, ...others } = data;
                const { source, ...other } = position;
                return {
                    ...element,
                    data: others,
                    position: other
                }
            }).filter((el: any) => el)
            const elementsStr = JSON.stringify(filteredElements)
            const checkElementsChangesStr = JSON.stringify(checkElement);
            if (flowDetail && flowDetail.type === "private") {
                if (elementsStr === checkElementsChangesStr && ((selectedAuthFlow || flowDetail && flowDetail.authFlow) === authFlow)) {
                    setSaveSuccess(true)
                    setBackFunctionality(true)
                } else if (elements.length > 1 && authFlow === null && selectedAuthFlow === null && flowDetail && flowDetail.authFlow && !widgetDrawer || elements.length > 1 && (authFlow !== (flowDetail && flowDetail.authFlow || selectedAuthFlow)) && !widgetDrawer) {
                    setSaveSuccess(false)
                    setBackFunctionality(true)
                } else if (widgetDrawer && elements.length > 1) {
                    setSaveSuccess(true)
                    setBackFunctionality(false)
                } else if (elements.length > 1) {
                    setSaveSuccess(false)
                    setBackFunctionality(true)
                }
            } else {
                if (elementsStr === checkElementsChangesStr) {
                    setSaveSuccess(true)
                    setBackFunctionality(true)
                } else if (saveSucces && !widgetDrawer) {
                    setSaveSuccess(false)
                    setBackFunctionality(true)
                } else if (widgetDrawer) {
                    setSaveSuccess(true)
                    setBackFunctionality(false)
                }
            }
        } else if (elements.length === 1) {
            setSaveSuccess(false)
        }   

        if (removePopertiesDetails && !widgetDrawer) {
            setProperties(null);
        }
    }, [nodes, edges, flowDetail && flowDetail.authFlow, selectedAuthFlow, widgetDrawer])

    const getFlowDetails = async (refetch = false, refetchCallback?:any) => {
        Http.get(`apps/${appId}/solo-flows/${soloId}?versionId=${appVersion && appversion.versionId}`).subscribe((res: any) => {
            dispatch(soloWindow(res))
            setFlowDetail(res);
            if (!res.source) {
                setNodes(initialElements)
                setEdges([])
                setElements(initialElements)
            }
            if (res.authFlow) {
                setAuthFlow(res.authFlow)
            }
            let lockData: any = {
                resourceLock: res?.resourceLock
            }
            if (refetch) {
                lockData = {
                    ...lockData,
                    message: 'SOLO_FORM_REFETCHED'
                }
            }
            if (refetchCallback) {
                lockData = {
                    ...lockData,
                    refetchedCallback: () => refetchCallback(res?.resourceLock)
                }
            }
            // send resource lock data to header
            ResourceLock.sendMessage(lockData)

            // send resource lock data to header
            ResourceLock.sendMessage({
                resourceLock: res?.resourceLock
            })
            setResourceLock(res.resourceLock)
        }, (err: any) => {
            dispatch(pushToast(
                { type: 'error', message: (err && err.message) ? err.message : 'Get Solo Details failed' }
            ))
        })
    }
    useEffect(() => {
        getFlowDetails();
        getForms();
        getSolo();
        getSoloServices();
        getSoloBuildInServices();
        // const find0sName = findSystemOperatingSystem();
        // if (find0sName) {
        //     setosName(find0sName)
        // }
    }, [])

    const refetchLockStatus = useCallback((callback?: any) => {
        Http.get(`apps/${appId}/solo-flows/${soloId}?versionId=${appVersion && appversion.versionId}`).subscribe((res: any) => {
            ResourceLock.sendMessage({
                message: 'SOLO_FORM_REFETCHED',
                resourceLock: res?.resourceLock || {},
                refetchedCallback: () => callback && callback(res?.resourceLock)
            })
        }, (err: any) => {
            dispatch(pushToast(
                {type: 'error', message: (err && err.message) ? err.message : 'Get Solo Details failed'}
            ))
        })
    }, [ appId, soloId, appversion?.versionId ]);
    
    useEffect(() => {
        const subscriber = ResourceLock.getMessage().subscribe(({ message, callback }) => {
            if (message === 'SOLO_BPMN_REFETCH') {
                getFlowDetails(true, callback)
            } else if (message === 'SOLO_BPMN_REFETCH_LOCK') {
                callback ? refetchLockStatus(callback) : refetchLockStatus()
            }
        })
        return () => subscriber.unsubscribe()
    }, [getFlowDetails, refetchLockStatus])

    const onConnectStart = (event: any, others: any) => {
        const findResumeEventNode = nodes.map((el: any) => {
            if (el.id === others.nodeId && el?.data?.propertyDetails?.eventName === "resume") {
                return el.id
            }
        }).filter((el: any) => { return el })
        if (others?.nodeId.includes("event") && findResumeEventNode.length <= 0) {
            setShowAllNodes(true)
        } else {
            setShowAllNodes(false)
        }
        if (others.handleId === "") {
            setDraggedFrom({ id: others.nodeId, handleId: others.handleId })
        } else {
            setDraggedFrom({ id: others.nodeId, handleId: others.handleId })
        }
    }

    const onConnectStop = (event: any) => {
        let position
        if (reactFlowWrapper !== null && reactFlowWrapper.current !== null) {
            const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
            position = reactFlowInstance?.project({
                x: event.clientX - reactFlowBounds.left,
                y: event.clientY - reactFlowBounds.top,
            });
        }
        setDragVisible(true)
        setNodePostion(position)
        setDragCoordinates({ x: event.x - 74, y: event.y - 74 })
    }

    const onDragAddNewNode = (item: any) => {
        // 1. hide the widgetlist...
        setDragVisible(false)
        // 2. create the new node....
        const newNode = {
            id: `${item.type}${uuid().substring(1, 7)}`,
            type: item.type,
            data: item,
            position: {
                x: nodePosition.x,
                y: nodePosition.y
            },
        }
        if (newNode.type === "condition") {
            newNode.data.propertyDetails = {
                name: newNode.id,
                condition: [{
                    id: "default",
                    expression: "true",
                    Name: "Default",
                    linkNode: "",
                    blocks: true,
                    nameCheck: false,
                    expand: false
                }]
            }
        }
        if (newNode.type === "aiClassifier") {
            newNode.data.propertyDetails = {
                name: newNode.id,
                classification: [{
                    id: "default",
                    name: "Default",
                    linkNode: "",
                    blocks: true,
                    nameCheck: false,
                    expand: false
                }]
            }
        }
        // 3. create a ne   w edge
        const edge = {
            source: draggedFrom.id,
            target: newNode.id,
            id: `reactflow__edge-${draggedFrom?.id ? draggedFrom.id : draggedFrom}null-${newNode.id}null`,
            type: "buttonedge",
            markerEnd: {
                type: MarkerType.ArrowClosed,
                color: "#657695", height: "20px",
                width: "20px"
            }, style: { stroke: "#657695", strokeWidth: 1.5 },
            sourceHandle: draggedFrom.handleId ? draggedFrom.handleId : null,
            targetHandle: null,
        }
        // 4. Update our elements state
        // setElements((elements: any) => [...elements, newNode, edge])
        setNodes((elements: any) => [...elements, newNode])
        setEdges((elements: any) => [...elements, edge])
        const findEvenNode = nodes.filter((el: any) => { return el.id === draggedFrom.id && draggedFrom.id.includes("event") })
        if (findEvenNode.length > 0) {
            if (findEvenNode[0].data?.propertyDetails?.eventName !== "resume") {
                if (eventNodeServiceConnections && eventNodeServiceConnections.length > 0) {
                    updateNodesContext('eventNodeServiceConnections', [...eventNodeServiceConnections, newNode.id])
                } else {
                    updateNodesContext('eventNodeServiceConnections', [newNode.id])
                }
            }
        }
    }

    const getStopNode = (uiNode: any, sourceId: string) => {
        let targets: any = []
        for (const key in uiNode) {
            if (key && uiNode[key] && uiNode[key].type === "stop" && uiNode[key].source === sourceId) {
                targets.push(key)
            }
            if (key && uiNode[key] && uiNode[key].type === "stop") {
                if (uiNode[key].source && Array.isArray(uiNode[key].source) && uiNode[key].source.length > 0) {
                    uiNode[key].source.forEach((sour: any) => {
                        if (sour === sourceId) {
                            targets.push(key)
                        }
                    })
                }
            }
        }
        return targets;
    }

    const onNodeDelete = (node: any) => {
        setNodes(nodes.filter((n: any) => {
            return n.id !== node[0].id
        }))
    }

    const onEdgeDelete = (edge: any) => {
        const findEdge = edges.filter((el: any) => { return el?.target === edge[0].target })
        if (eventNodeServiceConnections && eventNodeServiceConnections.includes(edge[0].target) && findEdge.length === 1) {
            let removeServiceId = eventNodeServiceConnections.filter((el: any) => el !== edge[0].target)
            updateNodesContext('eventNodeServiceConnections', removeServiceId)
        }
        const findSources = edge.filter((e: any) => { return e.source })
        setEdges(edges.filter((n: any) => {
            return !n.source.includes(findSources)
        }))
    }

    const onNodeClick = (event: any, element: any) => {
        if (!element.source) {
            setWidgetDrawer(true)
        } else {
            setWidgetDrawer(false)
        }
        const showPanel = event.target.tagName === 'IMG';
        if (showPanel) {
            setWidgetDrawer(false)
        }
        if (element.type === "error") {
            setWidgetDrawer(false)
        }
        onOpenNodeProperties(element);
    };


    const onEdgeMouseEnter = (event: any, edge: any) => {
        setEdges((prevState: any) => prevState.map((element: any) => element.id === edge.id ? {
            ...element, animated: true, type: "buttonedge", data: { lock, onRemoveElementsById, mouseEnter: true }, style: { stroke: "#657695", strokeWidth: 1.5 }
        } : element))
    }


    const onEdgeMouseLeave = (event: any, edge: any) => {
        setEdges((prevState: any) => prevState.map((element: any) => element.id === edge.id ? {
            ...element, animated: false, type: "buttonedge", data: { lock, onRemoveElementsById, mouseEnter: false }, style: { stroke: "#657695", strokeWidth: 1.5 }
        } : element))
    }

    const onRemoveElementsById = (id: string) => {
        if (eventNodeServiceConnections && eventNodeServiceConnections.includes(id)) {
            let removeServiceId = eventNodeServiceConnections.filter((el: any) => el !== id)
            updateNodesContext('eventNodeServiceConnections', removeServiceId)
        }
        if (id.includes("event")) {
            let removedEventNode = edges.filter((el: any) => { return el.source === id })
            if (removedEventNode.length > 0 && eventNodeServiceConnections.length > 0) {
                const findRemovedEvents = removedEventNode.map((el: any) => {
                    if (eventNodeServiceConnections.includes(el.target)) {
                        return el.target
                    }
                }).filter((el: any) => { return el })
                if (findRemovedEvents.length > 0 && eventNodeServiceConnections.length > 0) {
                    const findRemovedEventConnection = eventNodeServiceConnections.map((node: any) => {
                        if (!findRemovedEvents.includes(node)) {
                            return node
                        }
                    }).filter((el: any) => { return el })
                    updateNodesContext('eventNodeServiceConnections', findRemovedEventConnection)
                }
            }
        }
        const removeElement: any = findElementById(id);
        if (removeElement) {
            setNodes(nodes.filter((node: any) => {
                return node.id !== id
            }))
            setEdges(edges.filter((edge: any) => {
                return edge.target !== id && edge.source !== id
            }))
        }
    }


    const findElementById = (id: string) => {
        return (nodes && nodes.filter((item: any) => item.id === id)) || ([]);
    }

    const onNodeMouseEnter = (event: any, node: any) => {
        if (node) {
            let findSourceConnected = edges.filter((el: any) => { return (el.target === node.id) })
            if (findSourceConnected.length > 0) {
                dispatch(findSourceConnection(false))
            } else {
                dispatch(findSourceConnection(true))
            }
        }
        if (node.type !== "condition" && node.type !== "event" && node.type !== "aiClassifier") {
            let findNode = edges.filter((el: any) => { return (el.source === node.id) })
            if (findNode.length > 0) {
                updateNodesContext('connectable', false)
            } else {
                updateNodesContext('connectable', true)
            }
        } else {
            if (node.data.propertyDetails && node.data.propertyDetails.condition && node.data.propertyDetails.condition) {
                const { condition } = node.data.propertyDetails

                const findSourceHandle = edges.map((el: any) => {
                    if (el.hasOwnProperty("sourceHandle")) {
                        return el.source === node.id ? el.sourceHandle : "";
                    } else {
                        return ""
                    }
                }).filter((el: any) => _.camelCase(el))

                condition.forEach((el: any) => {
                    if (findSourceHandle.includes(_.camelCase(el.id))) {
                        el.connect = false;
                    } else {
                        el.connect = true;
                    }
                })

            } else if (node.data.propertyDetails && node.data.propertyDetails.conditions && node.data.propertyDetails.conditions) {
                const { conditions } = node.data.propertyDetails
                const findSourceHandle = edges.map((el: any) => {
                    if (el.hasOwnProperty("sourceHandle")) {
                        return el.source === node.id ? el.sourceHandle : "";
                    } else {
                        return ""
                    }
                }).filter((el: any) => _.camelCase(el))

                conditions.forEach((el: any) => {
                    if (findSourceHandle.includes(_.camelCase(el.name))) {
                        el.connect = false;
                    } else {
                        el.connect = true;
                    }
                })
            } else if (node.data.propertyDetails && node.data.propertyDetails.events && node.data.propertyDetails.events) {
                const { events } = node.data.propertyDetails
                const findSourceHandle = edges.map((el: any) => {
                    if (el.hasOwnProperty("sourceHandle")) {
                        return el.source === node.id ? el.sourceHandle : "";
                    } else {
                        return ""
                    }
                }).filter((el: any) => _.camelCase(el))

                events.forEach((el: any) => {
                    if (findSourceHandle.includes(_.camelCase(el.id))) {
                        el.connect = false;
                    } else {
                        el.connect = true;
                    }
                })
            } else if (node.data.propertyDetails && node.data.propertyDetails.eventHandler && node.data.propertyDetails.eventHandler) {
                const { eventHandler } = node.data.propertyDetails
                const findSourceHandle = edges.map((el: any) => {
                    if (el.hasOwnProperty("sourceHandle")) {
                        return el.source === node.id ? el.sourceHandle : "";
                    } else {
                        return ""
                    }
                }).filter((el: any) => _.camelCase(el))

                eventHandler.forEach((el: any) => {
                    if (findSourceHandle.includes(_.camelCase(el.name))) {
                        el.connect = false;
                    } else {
                        el.connect = true;
                    }
                })
            } else if (node.data.propertyDetails && node.data.propertyDetails.classifications && node.data.propertyDetails.classifications) {
                const { classifications } = node.data.propertyDetails
                const findSourceHandle = edges.map((el: any) => {
                    if (el.hasOwnProperty("sourceHandle")) {
                        return el.source === node.id ? el.sourceHandle : "";
                    } else {
                        return ""
                    }
                }).filter((el: any) => _.camelCase(el))

                classifications.forEach((el: any) => {
                    if (findSourceHandle.includes(_.camelCase(el.id))) {
                        el.connect = false;
                    } else {
                        el.connect = true;
                    }
                })
            } else if (node.data.propertyDetails && node.data.propertyDetails.classification && node.data.propertyDetails.classification) {
                const { classification } = node.data.propertyDetails
                const findSourceHandle = edges.map((el: any) => {
                    if (el.hasOwnProperty("sourceHandle")) {
                        return el.source === node.id ? el.sourceHandle : "";
                    } else {
                        return ""
                    }
                }).filter((el: any) => _.camelCase(el))

                classification.forEach((el: any) => {
                    if (findSourceHandle.includes(_.camelCase(el.name))) {
                        el.connect = false;
                    } else {
                        el.connect = true;
                    }
                })
            }
        }
        setNodes(nodes.map((element: any) =>
            element.id === node.id
                ? {
                    ...element,
                    data: {
                        ...element.data, id: element.id, lock, onRemoveNode: () => { setWidgetDrawer(false); onRemoveElementsById(node.id) }
                    },
                }
                : element
        )
        );
    };

    // useEffect(() => {
    //     const subscriber = ResourceLock.getMessage().subscribe(({message, resourceLock }) => {
    //         resourceLock ? setResourceLock(resourceLock) : setResourceLock({})
    //     })
    //     return () => subscriber.unsubscribe()
    // }, [])


    
    const getSolo = async () => {
        Http.get(`/apps/${appId}/solo-flows?versionId=${appVersion && appversion.versionId}`).subscribe((res: any) => {
            setSoloDetails(res);
            res?.flows?.forEach((f: any) => {
                if (f?.source?.nodes?.some((n: any) =>
                    n.next?.type === "return" ||
                    (n.type === "condition" && (n.conditions?.some((c: any) => c?.next?.type === "return"))) ||
                    (n.type === "event" && (n.eventHandlers?.some((e: any) => e?.next?.type === "return"))) ||
                    (n.type === "event" && (n.classifications?.some((e: any) => e?.next?.type === "return")))
                )) 
                {
                    returningSubflows.push(f.name as never)
                    updateNodesContext('returningSubflows', returningSubflows)
                }
            })
        }, (err: any) => {
            console.log(err)
        })
    }

    const getSoloServices = async () => {
        Http.get(`apps/${appId}/solo-services?versionId=${appVersion && appversion.versionId}`).subscribe((res: any) => {
            setSoloServices(res.services);
        }, (err: any) => {
            console.error(err)
        })
    }

    const getSoloBuildInServices = async () => {
        if ((!orgPermissions?.includes("app.View") || !orgPermissions?.includes("bpmn.View") ) &&  loggedInUserId!=selectedOrg?.owner) {
            ErrorToast("Not Authorized: Error fetching builtin services")
            return
        }
        Http.get(`/solo-services/builtin?appId=${appId}`).subscribe((res: any) => {
            setSoloBuildinServices(res.services)
        }, (err: any) => {
            if (err == "Forbidden") {
                ErrorToast("Not Authorized: Error fetching builtin services")
            }
        })
    }

    const getForms = async () => {
        Http.get(`apps/${appId}/forms?versionId=${appVersion && appversion.versionId}&branchId=${branchId}`).subscribe((res: any) => {
            setForms(res)
        }, err => {
            console.log(err)
        })
    }

    const saveFlowDetails = async (payload: any, isCommit:boolean, discard?: boolean) => {
        if (payload?.source?.nodes?.length === 0) {
            payload.source = {}
        }
        payload.name = flowDetail.name;
        payload.type = flowDetail.type;
        if (flowDetail.authFlow || selectedAuthFlow) {
            payload.authFlow = selectedAuthFlow || flowDetail.authFlow;
        }
        payload.versionId = appVersion && appversion.versionId;
        payload.branchId = branchId;
        // when discard and commit solo journey no need to update flow source so we have delete source.
        if (discard) {
            delete payload.source
            delete payload.ui
        }
        Http.put(`apps/${appId}/solo-flows/${soloId}?isCommit=${isCommit}${discard ? "&discard=true":""}`, payload).subscribe((resp: any) => {
            if (resp.warnings && resp.warnings.length > 0) {
                setIssueDetails({ warnings: resp.warnings });
                WarningToast('Solo Details updated with warnings')
                setSaveSuccess(true)
                setCheckElementsChanges(nodes.concat(edges))
            } else if (!resp.warnings && !resp.errors) {
                SuccessToast(`Solo details ${isCommit ? "committed": "updated"} successfully`)
                setSaveSuccess(true)
                setIssueDetails(null)
                setCheckElementsChanges(nodes.concat(edges))
            }
            getFlowDetails(false, null)
        }, (err: any) => {
            if (err && err?.code === 400) {
                if (err?.errors?.length > 0 || err?.warnings.length > 0 || err?.errorList?.length > 0) {
                    setIssueDetails(err);
                    setOpenIssues(true)
                }
            } else if (err) {
                ErrorToast((err && err.message) ? err.message : 'Failed to update solo details')
                setSaveSuccess(false)
            }
        })
    }

    const onNodeMouseMove = (event: any, node: any) => {
        setNodes((prevState: any) =>
            prevState.map((element: any) =>
                element.id === node.id ? { ...element, position: { x: node.position.x, y: node.position.y, type: node.type, } } : element
            ))
    }

    const onNodeMouseLeave = (event: any, node: any) => {
        setNodes((prevState: any) =>
            prevState.map((element: any) =>
                element.id === node.id ? { ...element, position: { x: node.position.x, y: node.position.y, type: node.type } } : element))
    }

    const onNodesChange = useCallback(
        (changes: any) => setNodes((node: any) => applyNodeChanges(changes, node)),
        [setNodes]
    );
    const onEdgesChange = useCallback(
        (changes: any) => setEdges((eds: any) => applyEdgeChanges(changes, eds)),
        [setEdges]
    );

    const onDrop = (event: any) => {
        event.preventDefault();
        const findErrorNode = nodes.filter((e: any) => { return e.type === "error" })
        const findEventsNodes = nodes.filter((el: any) => { return el.type === "event" })
        if (!lock) {
            if (reactFlowWrapper !== null && reactFlowWrapper.current !== null) {
                const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
                if (event.dataTransfer.getData('application/reactflow')) {
                    const data = JSON.parse(event.dataTransfer.getData('application/reactflow'));
                    if (data.type === "error" && findErrorNode.length > 0) {
                        WarningToast("Allowed to use only one error node")
                    }
                    if (data.type === "error" && findErrorNode.length > 0 || data.type === "event" && findEventsNodes.length >= 3) {
                        WarningToast(data.type === "error" ? "Allowed to use only one error node" : "All events already exist")
                    }
                    if ((data.type === "error" && findErrorNode.length === 0) || (data.type === "event" && findEventsNodes.length < 3) || data.type !== "event" && data.type !== "error") {
                        const position = reactFlowInstance?.project({
                            x: event.clientX - reactFlowBounds.left,
                            y: event.clientY - reactFlowBounds.top,
                        });
                        const newNode = {
                            id: data.type === "error" ? "error" : `${data.type}${uuid().substring(1, 7)}`,
                            type: data.type,
                            position,
                            data,
                        };
                        if (newNode.type === "condition") {
                            newNode.data.propertyDetails = {
                                name: newNode.id,
                                condition: [{
                                    id: "default",
                                    expression: "true",
                                    Name: "Default",
                                    linkNode: "",
                                    blocks: true,
                                    nameCheck: false,
                                    expand: false
                                }]
                            }
                        }
                        if (newNode.type === "aiClassifier") {
                            newNode.data.propertyDetails = {
                                name: newNode.id,
                                classification: [{
                                    id: "default",
                                    name: "Default",
                                    linkNode: "",
                                    blocks: true,
                                    nameCheck: false,
                                    expand: false
                                }]
                            }
                        }
                        // setElements((es: any) => es.concat(newNode));
                        setNodes((es: any) => es.concat(newNode));
                    }
                }
            }
        }
    };

    const onUpdateProperties = (propertyDetails: any) => {
        if (propertyDetails && !propertyDetails.idChange) {
            let filteredId = nodes.filter((el: any) => el.id !== propertyDetails.nodeId)
            for (let e of filteredId) {
                if (e.data && e.data.details && propertyDetails.name) {
                    if (e.data.details.name.trim() === propertyDetails.name.trim()) {
                        setNameCheck(true)
                        break;
                    }
                } else if (e.data && e.data.propertyDetails && propertyDetails.name && propertyDetails.name !== null) {
                    if (e.data.propertyDetails.name.trim() === propertyDetails.name.trim()) {
                        setNameCheck(true)
                        break;
                    }
                } else {
                    setNameCheck(false)
                    if (propertyDetails.type === "condition" || propertyDetails.type === "event" || propertyDetails.type === "aiClassifier" || propertiesDetail.type === "form") {
                        updateNodePropertiesDetails(propertyDetails)
                    }
                }
            }
        } else if (propertyDetails && propertyDetails.idChange) {
            updateNodePropertiesDetails(propertyDetails)
        }
    }

    const updateNodePropertiesDetails = (propertyDetails: any) => {
        //2. update the edges which points to those ID before
        setNodes((prevState: any) => {
            const updatedElements = prevState.map((element: any) => {
                // 1. set the id of the element to name
                if (element.id === propertyDetails.nodeId) {
                    // let id = _.camelCase(propertyDetails.name)
                    const updatedElement = {
                        ...element,
                        // id: _.camelCase(propertyDetails.name),
                        data: {
                            ...element.data,
                            propertyDetails: { ...propertyDetails },
                            edgeforLinkNode,
                            removedEdgeforLinkNode,
                            nextNodes,
                        }
                    }
                    setProperties({ nodeDetail: updatedElement })
                    return updatedElement
                }
                if (element.source && element.source === propertyDetails.nodeId) {
                    return {
                        ...element,
                        source: propertyDetails.nodeId,
                    }
                }
                if (element.target && element.target === propertyDetails.nodeId) {
                    return {
                        ...element,
                        target: propertyDetails.nodeId,
                    }
                }
                return element;
            })
            return updatedElements;
        })
    }


    const nextNodes = (id: any, nextNode: any) => {
        const findNode = edges.filter((el: any) => {
            return (el.source === id && el.target !== nextNode)
        })
        const findExistingNode = edges.filter((el: any) => {
            return (el.source === id)
        })

        const alreadyConnected = edges.filter((el: any) => {
            return (el.target === nextNode)
        })
        if (findNode.length > 0) {
            if (alreadyConnected.length === 0) {
                setEdges((prevState: any) => prevState.filter((el: any) => { return (el.source !== id && el.target !== nextNode) }))
            } else {
                setEdges((prevState: any) => prevState.filter((el: any) => { return (el.source !== id) }))
            }
            let edge = {
                id: `reactflow__edge-${id}null-${nextNode}null`,
                markerEnd: {
                    type: MarkerType.ArrowClosed,
                    color: "#657695", height: "20px",
                    width: "20px"
                }, source: id,
                connectionMode: "loose",
                sourceHandle: "null",
                type: "buttonedge",
                style: { stroke: "#657695", strokeWidth: 1.5 },
                target: nextNode,
                targetHandle: null
            }
            setEdges((prevState: any) => [...prevState, edge])
        } else if (findExistingNode.length === 0) {
            let edge = {
                id: `reactflow__edge-${id}null-${nextNode}null`,
                markerEnd: {
                    type: MarkerType.ArrowClosed,
                    color: "#657695", height: "20px",
                    width: "20px"
                }, source: id,
                connectionMode: "loose",
                sourceHandle: "null",
                type: "buttonedge",
                style: { stroke: "#657695", strokeWidth: 1.5 },
                target: nextNode,
                targetHandle: null
            }
            setEdges((prevState: any) => [...prevState, edge])
        }
    }

    const removedEdgeforLinkNode = (id: any, removeSource: boolean = false) => {
        if (id && !removeSource) {
            setEdges((prevState: any) => prevState.filter((el: any) => { return (el.sourceHandle !== id) }))
        } else if (id && removeSource) {
            setEdges((prevState: any) => prevState.filter((el: any) => { return (el.source !== id) }))
        }
    }

    const edgeforLinkNode = (sourceNode: any, targetNodeId: any, handleId: any, updatedId: any) => {
        if (sourceNode?.nodeId.includes("event") && sourceNode?.eventName !== "resume") {
            setEdges((edges: any) => edges.filter((edge: any) => { return edge.source !== targetNodeId }))
            if (eventNodeServiceConnections && eventNodeServiceConnections.length > 0) {
                updateNodesContext('eventNodeServiceConnections', [...eventNodeServiceConnections, targetNodeId])
            } else {
                updateNodesContext('eventNodeServiceConnections', [targetNodeId])
            }
        }
        // setElements(edges.concat(nodes))
        let sourceId = sourceNode && sourceNode.nodeId;
        //check duplicated and newly added edges
        const filteredEdge = edges.filter((el: any) => { return (el.source === sourceId && el.sourceHandle === handleId) })

        if (filteredEdge.length === 0 && !updatedId) {
            const edge = createNewEdge(sourceId, handleId, targetNodeId)
            setEdges((prevState: any) => [...prevState, edge])
        } else if (updatedId) {
            //one click updated icon it will comes here

            //find edges already connected
            const findEdge = edges.filter((el: any) => {
                return (el.sourceHandle === updatedId && sourceId === el.source)
            })

            //check if condition id and concdition updated id are same
            let condition;
            if (sourceNode.condition) {
                condition = sourceNode && sourceNode.condition.filter((el: any) => {
                    return el.id === updatedId
                })
            } else if(sourceNode.classification){
                condition = sourceNode && sourceNode.classification.filter((el: any) => {
                    return el.id === updatedId
                })
            }else{
                condition = sourceNode && sourceNode.events.filter((el: any) => {
                    return el.id === updatedId
                })
            }

            //it check for updatedid and linkNode
            const newHandleId = edges.filter((el: any) => {
                return el.sourcehandle === handleId && sourceId === el.source
            })

            if (findEdge.length === 1) {
                setEdges((prevState: any) => prevState.filter((el: any) => { return (el.sourceHandle !== updatedId || el.sourceHandle === updatedId && el.source !== sourceId) }))
                if (condition.length > 0) {
                    const edge = createNewEdge(sourceId, updatedId, condition[0].linkNode)
                    setEdges((prevState: any) => [...prevState, edge])
                } else if (newHandleId.length === 0) {
                    const edge = createNewEdge(sourceId, handleId, targetNodeId)
                    if (edge) {
                        if (!edges.some((el: any) => el.sourceHandle === handleId && el.source === sourceId)) {
                            setEdges((prevState: any) => [...prevState, edge])
                        }
                    }
                }
            } else {
                if (condition.length) {
                    const edge = createNewEdge(sourceId, updatedId, condition[0].linkNode ? condition[0].linkNode : targetNodeId)
                    if (filteredEdge.length === 0) {
                        setEdges((prevState: any) => [...prevState, edge])
                    }
                } else {
                    if (filteredEdge.length === 0) {
                        const edge = createNewEdge(sourceId, handleId, targetNodeId)
                        setEdges((prevState: any) => [...prevState, edge])
                    }
                }
            }
        }
    }

    const createNewEdge = (sourceId: string, handleId: string, targetNodeId: string) => {
        return {
            id: `reactflow__edge-${sourceId}${`${handleId}`}-${targetNodeId}null`,
            markerEnd: {
                type: MarkerType.ArrowClosed,
                color: "#657695", height: "20px",
                width: "20px"
            },
            source: sourceId,
            type: "buttonedge",
            connectionMode: "loose",
            sourceHandle: `${handleId}`,
            style: { stroke: "#657695", strokeWidth: 1.5 },
            target: targetNodeId,
            targetHandle: null
        }
    }

    const onConnect = (params: any) => {
        // params.sourceHandle = getId();
        // params.targetHandle = getId();
        // params.arrowHeadType = ArrowHeadType.ArrowCl osed;
        params.markerEnd = {
            type: MarkerType.ArrowClosed,
            color: "#657695", height: "20px",
            width: "20px"
        };
        params.type = "buttonedge",
            params.style = { stroke: "#657695", strokeWidth: 1.5 };
        setEdges((els: any) => addEdge(params, els));
        if (params.source.includes("event")) {
            const findEvenNode = nodes.filter((el: any) => { return el.id === params.source })
            if (findEvenNode.length > 0 && findEvenNode[0].data?.propertyDetails?.eventName !== "resume") {
                if (eventNodeServiceConnections && eventNodeServiceConnections.length > 0) {
                    updateNodesContext('eventNodeServiceConnections', [...eventNodeServiceConnections, params.target])
                } else {
                    updateNodesContext('eventNodeServiceConnections', [params.target])
                }
            }
            const findEdges = edges.filter((el: any) => {
                return params.target === el.source
            })
            if (findEdges.length > 0) {
                setEdges((prevState: any) => prevState.filter((el: any) => { return (el.target !== findEdges[0].target) }))
            }
        }
        setDragVisible(false);
    };


    const onInit = (_reactFlowInstance: any) => {
        setReactFlowInstance(_reactFlowInstance);
    }

    const onDragOver = (event: any) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    };


    const onOpenNodeProperties = (nodeDetail: any) => {
        setProperties({
            nodeDetail
        });
        setNewNodeDetail(null);
    }


    const onAddNewNode = (newNode: any, sourceNode: any, targetNode: any, edge: any
    ) => {
        let removeEdge = elements.filter((el: any) => el.id !== edge.id)
        const newNodeCreate = {
            id: `${newNode.type}${uuid().substring(1, 7)}`,
            type: newNode.type,
            data: newNode,
            Position: targetNode.position && sourceNode.position && {
                x: Math.abs(targetNode.position.x + sourceNode.position.x) / 2, y: Math.abs(targetNode.position.y + sourceNode.position.y) / 2
            }
        }
        const startEdge = {
            ...edge,
            source: sourceNode.id,
            target: newNodeCreate.id,
            id: `reactflow__edge-${sourceNode.id}null-${newNodeCreate.id}null`
        }
        const endEdge = {
            ...edge,
            source: newNodeCreate.id,
            target: targetNode.id,
            id: `reactflow__edge-${newNodeCreate.id}null-${targetNode.id}null`
        }
        removeEdge = [...removeEdge, newNodeCreate, startEdge, endEdge]
        setNewNodeDetail(null)
        setElements(removeEdge)
    };

    const onSave = (elements: any, isCommit:boolean, discard?: boolean) => {
        let edges = [];
        let nodes: any = {};
        let position: any = {};
        let payload: any = {
            source: {
                startNode: "",
                nodes: []
            },
            ui: {
                position: null
            }
        }
        for (let item of elements) {
            if (item.source) {
                edges.push(item)
            } else if (item.position) {
                if (!nodes[item.id]) {
                    nodes[item.id] = item
                }
                position[item.id] = {
                    x: item.position.x,
                    y: item.position.y,
                    type: item.type
                }
            }
        }
        for (const key in nodes) {
            let nextNodes: any = null;
            if (nodes[key] && elements.length > 1) {
                if (nodes[key].type.toLowerCase() === "start") {
                    const initialNode = findNextNodes(nodes, edges, nodes[key].id);
                    if (initialNode.length > 0 && initialNode[0].type !== "stop" && initialNode[0].type !== "return") {
                        payload.source.startNode = initialNode[0].id;
                        nextNodes = findNextNodes(nodes, edges, initialNode[0].id);
                        let next: any = {
                            type: ""
                        }
                        let newNode: any = {
                            id: initialNode[0].id,
                            name: initialNode[0].type === "error" ? "error" : initialNode[0].id,
                            type: initialNode[0].type,
                            next
                        }
                        if (initialNode[0].data.propertyDetails) {
                            if (newNode.type === "service") {
                                if (initialNode[0].data.propertyDetails && !initialNode[0].data.propertyDetails.params) {
                                    const variables: any = {}
                                    initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.serviceKeyValue && initialNode[0].data.propertyDetails.serviceKeyValue.forEach((el: any) => {
                                        const { key, id, src, changeType, nameCheck, required, showCloseIcon, ...others } = el;
                                        variables[el.key] = {
                                            valueInfo: {},
                                            ...others,
                                        }
                                    });
                                    if (initialNode[0].data.propertyDetails && !initialNode[0].data.propertyDetails.selectedserviceName) {
                                        newNode = {
                                            ...newNode,
                                            name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                            params: variables,
                                        }
                                    } else {
                                        newNode = {
                                            ...newNode,
                                            name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                            serviceName: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.selectedserviceName,
                                            serviceType: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.serviceType,
                                            serviceKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.serviceKey,
                                            params: variables,
                                        }
                                    }
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey) {
                                        newNode = {
                                            ...newNode,
                                            formKey: initialNode[0].data.propertyDetails.formKey
                                        }
                                    }
                                } else {
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.params) {
                                        Object.entries(initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.params).forEach(([i, values]: any) => {
                                            const { params = {} } = initialNode[0].data.propertyDetails;
                                            if (values.hasOwnProperty("changeType") && values.hasOwnProperty("showCloseIcon")) {
                                                delete params[i].changeType
                                                delete params[i].showCloseIcon
                                            }
                                        })
                                    }
                                    newNode = {
                                        ...newNode,
                                        name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                        serviceName: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.serviceName,
                                        serviceType: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.serviceType,
                                        serviceKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.serviceKey,
                                        params: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.params,
                                    }
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.key) {
                                        newNode = {
                                            ...newNode,
                                            formKey: initialNode[0].data.propertyDetails.key
                                        }
                                    }
                                }
                            }
                            if (newNode.type === "form") {
                                if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.selectedForm) {
                                    if (initialNode[0].data.propertyDetails && !initialNode[0].data.propertyDetails.formKey) {
                                        newNode = {
                                            ...newNode,
                                            name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                            completionCriteria:  initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.completionCriteria
                                            //selectedForm: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.selectedForm,
                                            //formKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.key
                                        }
                                    } else {
                                        newNode = {
                                            ...newNode,
                                            name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                            //selectedForm: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.selectedForm,
                                            formKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey,
                                            completionCriteria:  initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.completionCriteria
                                        }
                                    }
                                } else {
                                    newNode = {
                                        ...newNode,
                                        name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                        //selectedForm: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.selectedForm,
                                        formKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.key,
                                        completionCriteria:  initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.completionCriteria
                                    }
                                }
                            }
                            if (newNode.type === "timer") {
                                if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.selectedForm) {
                                    if (initialNode[0].data.propertyDetails && !initialNode[0].data.propertyDetails.formKey) {
                                        newNode = {
                                            ...newNode,
                                            name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                            waitTime: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.waitTime || {},
                                            //formKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.key
                                        }
                                    } else {
                                        newNode = {
                                            ...newNode,
                                            name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                            waitTime: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.waitTime || {},
                                            formKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey
                                        }
                                    }
                                } else {
                                    newNode = {
                                        ...newNode,
                                        name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                        waitTime: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.waitTime || {},
                                        formKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.key
                                    }
                                }
                            }
                            if (newNode.type === "condition") {
                                if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.condition) {
                                    const values = initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.condition.map((con: any) => {
                                        let nodeId: any
                                        elements.forEach((e: any) => {
                                            if (initialNode[0].id === e.source && con.id === e.sourceHandle) {
                                                nodeId = e.target;
                                            }
                                            return nodeId
                                        })
                                        return { name: con.Name, expr: con.expression, nodeId }
                                    })
                                    const data: any = values && values.map((value: any) => {
                                        const { nodeId, ...others } = value
                                        if (value.nodeId !== undefined && value.nodeId.startsWith("stop")) {
                                            return { ...others, next: { type: "end", nodeId: value.nodeId } }
                                        } else if (value.nodeId !== undefined && value.nodeId.startsWith("subflow")) {
                                            return { ...others, next: { type: "flow", nodeId: value.nodeId } }
                                        } else if (value.nodeId !== undefined && value.nodeId.startsWith("return")) {
                                            return { ...others, next: { type: "return", nodeId: value.nodeId } }
                                        } else if (value.nodeId) {
                                            return { ...others, next: { type: "node", nodeId: value.nodeId } }
                                        } else {
                                            return { ...others, next: { type: "node" } }
                                        }
                                    })

                                    const payload = data && data.map((el: any) => {
                                        const { expr, ...others } = el
                                        if (expr) {
                                            return { ...el }
                                        } else {
                                            return { ...others }
                                        }
                                    })

                                    nextNodes.map((n: any) => {
                                        if (n.type === "stop" || n.type === "return") {
                                            if (position[n.id]) {
                                                position[n.id].source = initialNode[0].id;
                                            }
                                        }
                                    })

                                    newNode = {
                                        ...newNode,
                                        name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                        conditions: payload
                                    }
                                } else {
                                    const values = initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.conditions && initialNode[0].data.propertyDetails.conditions.map((con: any) => {
                                        let nodeId: any
                                        elements.forEach((e: any) => {
                                            if (initialNode[0].id === e.source && _.camelCase(con.name) === e.sourceHandle) {
                                                nodeId = e.target;
                                            }
                                            return nodeId
                                        })
                                        return { name: con.name, expr: con.expr, nodeId }
                                    })
                                    const data: any = values && values.map((value: any) => {
                                        const { nodeId, ...others } = value
                                        if (value.nodeId !== undefined && value.nodeId.startsWith("stop")) {
                                            return { ...others, next: { type: "end", nodeId: value.nodeId } }
                                        } else if (value.nodeId !== undefined && value.nodeId.startsWith("subflow")) {
                                            return { ...others, next: { type: "flow", nodeId: value.nodeId } }
                                        } else if (value.nodeId !== undefined && value.nodeId.startsWith("return")) {
                                            return { ...others, next: { type: "return", nodeId: value.nodeId } }
                                        } else if (value.nodeId) {
                                            return { ...others, next: { type: "node", nodeId: value.nodeId } }
                                        } else {
                                            return { ...others, next: { type: "node" } }
                                        }
                                    })

                                    const payload = data && data.map((el: any) => {
                                        const { expr, ...others } = el
                                        if (expr) {
                                            return { ...el }
                                        } else {
                                            return { ...others }
                                        }
                                    })

                                    nextNodes.map((n: any) => {
                                        if (n.type === "stop" || n.type === "return") {
                                            if (position[n.id]) {
                                                position[n.id].source = initialNode[0].id;
                                            }
                                        }
                                    })

                                    newNode = {
                                        ...newNode,
                                        name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                        conditions: payload
                                    }
                                }
                            }
                            if (newNode.type === "event") {
                                if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.events) {
                                    const values = initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.events.map((con: any) => {
                                        let nodeId: any
                                        elements.forEach((e: any) => {
                                            if (initialNode[0].id === e.source && con.id === e.sourceHandle) {
                                                nodeId = e.target;
                                            }
                                            return nodeId
                                        })
                                        return { name: con.Name, handler: con.handler, nodeId }
                                    })
                                    const data: any = values && values.map((value: any) => {
                                        const { nodeId, ...others } = value
                                        if (value.nodeId !== undefined && value.nodeId.startsWith("stop")) {
                                            return { ...others, next: { type: "end", nodeId: value.nodeId } }
                                        } else if (value.nodeId !== undefined && value.nodeId.startsWith("subflow")) {
                                            return { ...others, next: { type: "flow", nodeId: value.nodeId } }
                                        } else if (value.nodeId !== undefined && value.nodeId.startsWith("return")) {
                                            return { ...others, next: { type: "return", nodeId: value.nodeId } }
                                        } else if (value.nodeId) {
                                            return { ...others, next: { type: "node", nodeId: value.nodeId } }
                                        } else {
                                            return { ...others, next: { type: "node" } }
                                        }
                                    })

                                    const payload = data && data.map((el: any) => {
                                        const { handler, ...others } = el
                                        if (handler) {
                                            return { ...el }
                                        } else {
                                            return { ...others }
                                        }
                                    })

                                    nextNodes.map((n: any) => {
                                        if (n.type === "stop" || n.type === "return") {
                                            if (position[n.id]) {
                                                position[n.id].source = initialNode[0].id;
                                            }
                                        }
                                    })

                                    newNode = {
                                        ...newNode,
                                        name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                        eventName: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.eventName || "resume"),
                                        eventHandlers: payload
                                    }
                                } else {
                                    const values = initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.eventHandler && initialNode[0].data.propertyDetails.eventHandler.map((con: any) => {
                                        let nodeId: any
                                        elements.forEach((e: any) => {
                                            if (initialNode[0].id === e.source && _.camelCase(con.name) === e.sourceHandle) {
                                                nodeId = e.target;
                                            }
                                            return nodeId
                                        })
                                        return { name: con.name, handler: con.handler, nodeId }
                                    })

                                    const data: any = values && values.map((value: any) => {
                                        const { nodeId, ...others } = value
                                        if (value.nodeId !== undefined && value.nodeId.startsWith("stop")) {
                                            return { ...others, next: { type: "end", nodeId: value.nodeId } }
                                        } else if (value.nodeId !== undefined && value.nodeId.startsWith("subflow")) {
                                            return { ...others, next: { type: "flow", nodeId: value.nodeId } }
                                        } else if (value.nodeId !== undefined && value.nodeId.startsWith("return")) {
                                            return { ...others, next: { type: "return", nodeId: value.nodeId } }
                                        } else if (value.nodeId) {
                                            return { ...others, next: { type: "node", nodeId: value.nodeId } }
                                        } else {
                                            return { ...others, next: { type: "node" } }
                                        }
                                    })

                                    const payload = data && data.map((el: any) => {
                                        const { handler, ...others } = el
                                        if (handler) {
                                            return { ...el }
                                        } else {
                                            return { ...others }
                                        }
                                    })

                                    nextNodes.map((n: any) => {
                                        if (n.type === "stop" || n.type === "return") {
                                            if (position[n.id]) {
                                                position[n.id].source = initialNode[0].id;
                                            }
                                        }
                                    })

                                    newNode = {
                                        ...newNode,
                                        name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                        eventName: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.eventName || "resume"),
                                        eventHandlers: payload
                                    }
                                }
                            }
                            else if (newNode.type === "assistedJourney") {
                                if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.keyValue) {
                                    const variables: any = {}
                                    initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.keyValue && initialNode[0].data.propertyDetails.keyValue.forEach((el: any) => {
                                        const { key, id, src, nameCheck, ...others } = el;
                                        variables[el.key] = {
                                            valueInfo: {},
                                            ...others,
                                        }
                                    })

                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.processDefinitionKey) {
                                        newNode = {
                                            ...newNode,
                                            name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                            processDefinitionKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.processDefinitionKey,
                                            waitForCompletion: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.completion || false,
                                            outputVariables: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.outputVariables,
                                            inputVariables: variables
                                        }
                                    } else {
                                        newNode = {
                                            ...newNode,
                                            name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                            //processDefinitionKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.processDefinitionKey && initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.processDefinitionKey,
                                            waitForCompletion: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.completion || false,
                                            outputVariables: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.outputVariables,
                                            inputVariables: variables
                                        }
                                    }
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.webhookHandler.serviceName) {
                                        newNode = {
                                            ...newNode,
                                            webhookHandler: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.webhookHandler
                                        }
                                    }
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey) {
                                        newNode = {
                                            ...newNode,
                                            formKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey
                                        }
                                    }
                                    if (initialNode[0].data.propertyDetails.sessionVariables) {
                                        newNode = {
                                            ...newNode,
                                            sessionVariables: initialNode[0].data.propertyDetails.sessionVariables
                                        }
                                    }
                                } else if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.inputVariables) {
                                    newNode = {
                                        ...newNode,
                                        name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                        processDefinitionKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.processDefinitionKey && initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.processDefinitionKey,
                                        waitForCompletion: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.completion || false,
                                        outputVariables: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.outputVariables,
                                        inputVariables: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.inputVariables
                                    }
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.webhookHandler.serviceName) {
                                        newNode = {
                                            ...newNode,
                                            webhookHandler: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.webhookHandler
                                        }
                                    }
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey) {
                                        newNode = {
                                            ...newNode,
                                            formKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey
                                        }
                                    }
                                    if (initialNode[0].data.propertyDetails.sessionVariables) {
                                        newNode = {
                                            ...newNode,
                                            sessionVariables: initialNode[0].data.propertyDetails.sessionVariables
                                        }
                                    }
                                }
                            } else if (newNode.type === "webhook") {
                                if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.apiResponseHandler) {
                                    newNode = {
                                        ...newNode,
                                        name: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.name || initialNode[0].id
                                    }
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey) {
                                        newNode = {
                                            ...newNode,
                                            formKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey
                                        }
                                    }
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.apiResponseHandler && initialNode[0].data.propertyDetails.apiResponseHandler.serviceName) {
                                        newNode = {
                                            ...newNode,
                                            requestService: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.apiResponseHandler
                                        }
                                    }
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.webhookHandler && initialNode[0].data.propertyDetails.webhookHandler.serviceName) {
                                        newNode = {
                                            ...newNode,
                                            webhookHandler: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.webhookHandler
                                        }
                                    }
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.emailSubject && initialNode[0].data.propertyDetails.emailBody) {
                                        newNode = {
                                            ...newNode,
                                            emailNotification: { "subject": initialNode[0].data.propertyDetails.emailSubject, "body": initialNode[0].data.propertyDetails.emailBody }
                                        }
                                    }
                                } else if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.requestService) {
                                    newNode = {
                                        ...newNode,
                                        name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                        formKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey,
                                        emailNotification: { "subject": initialNode[0].data.propertyDetails.emailSubject, "body": initialNode[0].data.propertyDetails.emailBody }
                                    }
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.webhookHandler.serviceName) {
                                        newNode = {
                                            ...newNode,
                                            webhookHandler: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.webhookHandler
                                        }
                                    }
                                    if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.requestService.serviceName) {
                                        newNode = {
                                            ...newNode,
                                            requestService: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.requestService,
                                        }
                                    }
                                }


                            } else if(newNode.type === "message") {
                                const details = initialNode[0].data.propertyDetails
                                newNode = {
                                    ...newNode,
                                    name: details.name.length ? details.name : newNode.id,
                                    onEnter: (details.onEnter ?? []).map((el: any) => {
                                      const { _id, chosen, selected, ...rest } = el
                                      return rest
                                    }),
                                    waitForUserMessage: details.waitForUserMessage ?? false,
                                }
                                if(details.waitForUserMessage) {
                                    newNode.onReceive = (details.onReceive ?? []).map((el: any) => {
                                      const { _id, chosen, selected, ...rest } = el
                                      return rest
                                    })
                                }
                            } else if(newNode.type === "liveAgent") {
                                const details = initialNode[0].data.propertyDetails
                                newNode = {
                                    ...newNode,
                                    name: details.name.length ? details.name : newNode.id,
                                }
                                if(details.params) {
                                    newNode.params = Object.keys(details.params).reduce((acc, curr) => {
                                      const val = details.params[curr]
                                      if(val.value?.trim().length) {
                                        acc[curr] = val
                                      }
                                      return acc
                                    }, {} as Record<string, any>)
                                }
                            } else if(newNode.type === "subflow") {
                                const details = initialNode[0].data.propertyDetails
                                newNode = {
                                    ...newNode,
                                    name: details.name.length ? details.name : newNode.id,
                                    flowName: details.flowName,
                                    startNode: details.startNode
                                }
                            } else if (newNode.type === 'action') {
                                const {propertyDetails = {}} = nodes[key]?.data || {}
                                newNode = {
                                    ...newNode,
                                    integrationName: propertyDetails.integrationName,
                                    actionName: propertyDetails.actionName,
                                    inputVars: propertyDetails.inputVars, 
                                    responseBind: propertyDetails.responseBind,
                                    type: "action",
                                    name: propertyDetails && (propertyDetails.name || nodes[key].id),
                                    ...((propertyDetails && propertyDetails.formKey) && { formKey: propertyDetails.formKey }),
                                    ...((propertyDetails && propertyDetails.variableAcl) && { variableAcl: propertyDetails.variableAcl }),
                                }
                            } else if (newNode.type === "aiAgent") {
                                const { propertyDetails = {} } = initialNode[0]?.data || {}
                                if (!propertyDetails && propertyDetails.aiAgentKey) {
                                    newNode = {
                                        ...newNode,
                                        name: propertyDetails && (propertyDetails.name || nodes[key].id),
                                    }
                                } else if (propertyDetails?.aiAgentKey) {
                                        newNode = {
                                            ...newNode,
                                            name: propertyDetails && (propertyDetails.name || nodes[key].id),
                                            inputQuery: propertyDetails && propertyDetails.inputQuery,
                                            aiAgentKey: propertyDetails?.aiAgentKey || agentDetails.key,                                            
                                            ...((propertyDetails && propertyDetails.formKey) ? {formKey: propertyDetails && propertyDetails.formKey} : {}),
                                            inputVars: Array.isArray(propertyDetails?.inputVariable) ? propertyDetails?.inputVariable?.reduce((acc: any, curr: any) => {
                                                acc[curr.key] = curr.value;
                                                return acc;
                                            }, {}) : propertyDetails?.inputVariable,
                                            ...(!propertyDetails?.enableDestructure
                                                ? { responseBind: propertyDetails?.outputVariable }
                                                : {
                                                    responseBind: Array.isArray(propertyDetails?.outputVariable) ? propertyDetails?.outputVariable?.reduce((acc: any, curr: any) => {
                                                        acc[curr.value] = curr.key;
                                                        return acc;
                                                    }, {}) : propertyDetails?.outputVariable
                                                }) 
                                        }
                                } else {
                                    newNode = {
                                        ...newNode,
                                        name: propertyDetails && (propertyDetails.name || nodes[key].id),
                                        inputQuery: propertyDetails && propertyDetails.inputQuery,
                                        ...((propertyDetails && propertyDetails.formKey) ? { formKey: propertyDetails && propertyDetails.formKey } : {}),
                                        aiAgentKey: propertyDetails?.aiAgentKey || agentDetails.key || propertyDetails?.agentKey,
                                        inputVars: propertyDetails?.inputVariable,
                                        ...(!propertyDetails?.enableDestructure 
                                            ? { responseBind: propertyDetails?.outputVariable }
                                            : {
                                                responseBind: propertyDetails?.outputVariable
                                            }) 
                                    }
                                }
                            }
                            if (newNode.type === "aiClassifier") {
                                if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.classification) {
                                    const values = initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.classification.map((con: any) => {
                                        let nodeId: any
                                        elements.forEach((e: any) => {
                                            if (initialNode[0].id === e.source && con.id === e.sourceHandle) {
                                                nodeId = e.target;
                                            }
                                            return nodeId
                                        })
                                        return { name: con.name, description: con.description, nodeId }
                                    })
                                    const data: any = values && values.map((value: any) => {
                                        const { nodeId, ...others } = value
                                        if (value.nodeId !== undefined && value.nodeId.startsWith("stop")) {
                                            return { ...others, next: { type: "end", nodeId: value.nodeId } }
                                        } else if (value.nodeId !== undefined && value.nodeId.startsWith("subflow")) {
                                            return { ...others, next: { type: "flow", nodeId: value.nodeId } }
                                        } else if (value.nodeId !== undefined && value.nodeId.startsWith("return")) {
                                            return { ...others, next: { type: "return", nodeId: value.nodeId } }
                                        } else if (value.nodeId) {
                                            return { ...others, next: { type: "node", nodeId: value.nodeId } }
                                        } else {
                                            return { ...others, next: { type: "node" } }
                                        }
                                    })

                                    const payload = data && data.map((el: any) => {
                                        const { expr, ...others } = el
                                        if (expr) {
                                            return { ...el }
                                        } else {
                                            return { ...others }
                                        }
                                    })

                                    nextNodes.map((n: any) => {
                                        if (n.type === "stop" || n.type === "return") {
                                            if (position[n.id]) {
                                                position[n.id].source = initialNode[0].id;
                                            }
                                        }
                                    })

                                    newNode = {
                                        ...newNode,
                                        inputQuery: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.inputQuery || ""),
                                        name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                        ...((initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey) ? {formKey:  initialNode[0].data.propertyDetails &&  initialNode[0].data.propertyDetails.formKey}: {}),
                                        llm: initialNode[0]?.data?.propertyDetails?.llm,
                                        classifications: payload
                                    }
                                } else {
                                    const values = initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.classifications && initialNode[0].data.propertyDetails.classifications.map((con: any) => {
                                        let nodeId: any
                                        elements.forEach((e: any) => {
                                            if (initialNode[0].id === e.source && _.camelCase(con.name) === e.sourceHandle) {
                                                nodeId = e.target;
                                            }
                                            return nodeId
                                        })
                                        return { name: con.name, description: con.description, nodeId }
                                    })
                                    const data: any = values && values.map((value: any) => {
                                        const { nodeId, ...others } = value
                                        if (value.nodeId !== undefined && value.nodeId.startsWith("stop")) {
                                            return { ...others, next: { type: "end", nodeId: value.nodeId } }
                                        } else if (value.nodeId !== undefined && value.nodeId.startsWith("subflow")) {
                                            return { ...others, next: { type: "flow", nodeId: value.nodeId } }
                                        } else if (value.nodeId !== undefined && value.nodeId.startsWith("return")) {
                                            return { ...others, next: { type: "return", nodeId: value.nodeId } }
                                        } else if (value.nodeId) {
                                            return { ...others, next: { type: "node", nodeId: value.nodeId } }
                                        } else {
                                            return { ...others, next: { type: "node" } }
                                        }
                                    })

                                    const payload = data && data.map((el: any) => {
                                        const { expr, ...others } = el
                                        if (expr) {
                                            return { ...el }
                                        } else {
                                            return { ...others }
                                        }
                                    })

                                    nextNodes.map((n: any) => {
                                        if (n.type === "stop" || n.type === "return") {
                                            if (position[n.id]) {
                                                position[n.id].source = initialNode[0].id;
                                            }
                                        }
                                    })

                                    newNode = {
                                        ...newNode,
                                        inputQuery: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.inputQuery || "",
                                        llm: initialNode[0]?.data?.propertyDetails?.llm,
                                        ...((initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey) ? { formKey: initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.formKey } : {}),
                                        name: initialNode[0].data.propertyDetails && (initialNode[0].data.propertyDetails.name || initialNode[0].id),
                                        classifications: payload
                                    }
                                }
                            }

                            // Update variable acl
                            if (initialNode[0].data.propertyDetails && initialNode[0].data.propertyDetails.variableAcl) {
                                newNode = {
                                    ...newNode,
                                    variableAcl: initialNode[0].data.propertyDetails.variableAcl
                                }
                            }
                        }

                        if (initialNode[0].type.toLowerCase() !== "event" && initialNode[0].type.toLowerCase() !== "condition" && initialNode[0].type !== "aiClassifier" && nextNodes.length > 0) {
                            if (nextNodes[0].type === "stop") {
                                next.type = "end"
                                if (position[nextNodes[0].id]) {
                                    position[nextNodes[0].id].source = initialNode[0].id;
                                }
                            } else if (nextNodes[0].type === "return") {
                                next.type = "return"
                                if (position[nextNodes[0].id]) {
                                    position[nextNodes[0].id].source = initialNode[0].id;
                                }
                            } else {
                                if (nextNodes[0].type === "subflow") {
                                    next.type = "flow"
                                } else {
                                    next.type = "node"
                                }
                                next['nodeId'] = nextNodes[0].id
                            }
                        }
                        if (!next.nodeId && next.type !== "end" && next.type !== "return" && newNode.type !== "start") {
                            delete newNode.next;
                        }
                        if (newNode.type !== "start" && newNode.type !== "stop" && newNode.type !== "return") {
                            payload.source.nodes.push(newNode)
                        }
                    } else if (nodes[key].type !== "start" && nodes[key].type !== "stop" && nodes[key].type !== "return") {
                        payload.source.nodes.push({
                            id: nodes[key].id,
                            name: nodes[key].id,
                            type: nodes[key].type
                        })
                    } else if (!issueDetails) {
                        WarningToast("Please provide a valid flow")
                    }

                } else if (payload.source.startNode !== nodes[key].id) {
                    nextNodes = findNextNodes(nodes, edges, nodes[key].id);
                    let next: any = {
                        type: ""
                    }
                    let newNode: any = {
                        id: nodes[key].id,
                        name: nodes[key].type === "error" ? "error" : nodes[key].id,
                        type: nodes[key].type,
                        next
                    }
                    if (nodes[key].data.propertyDetails) {
                        if (newNode.type === "service") {
                            if (nodes[key].data.propertyDetails && !nodes[key].data.propertyDetails.params) {
                                const variables: any = {}
                                nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.serviceKeyValue && nodes[key].data.propertyDetails.serviceKeyValue.forEach((el: any) => {
                                    const { key, src, id, changeType, nameCheck, showCloseIcon, required, ...others } = el;
                                    variables[el.key] = {
                                        valueInfo: {},
                                        ...others,
                                    }
                                })
                                if (nodes[key].data.propertyDetails && !nodes[key].data.propertyDetails.selectedserviceName) {
                                    newNode = {
                                        ...newNode,
                                        name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                        //serviceName: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.selectedserviceName,
                                        params: variables,
                                    }
                                } else {
                                    newNode = {
                                        ...newNode,
                                        name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                        serviceName: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.selectedserviceName,
                                        serviceType: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.serviceType,
                                        serviceKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.serviceKey,
                                        params: variables,
                                    }
                                }
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey) {
                                    newNode = {
                                        ...newNode,
                                        formKey: nodes[key].data.propertyDetails.formKey
                                    }
                                }
                            } else {
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.params) {
                                    Object.entries(nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.params).forEach(([i, values]: any) => {
                                        const { params = {} } = nodes[key].data.propertyDetails;
                                        if (values.hasOwnProperty("changeType") && values.hasOwnProperty("showCloseIcon")) {
                                            delete params[i].changeType
                                            delete params[i].showCloseIcon
                                        }
                                    })
                                }
                                newNode = {
                                    ...newNode,
                                    name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                    serviceName: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.serviceName,
                                    serviceType: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.serviceType,
                                    serviceKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.serviceKey,
                                    params: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.params,
                                }
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.key) {
                                    newNode = {
                                        ...newNode,
                                        formKey: nodes[key].data.propertyDetails.key
                                    }
                                }
                            }
                        }
                        if (newNode.type === "form") {
                            if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.selectedForm) {
                                if (nodes[key].data.propertyDetails && !nodes[key].data.propertyDetails.formKey) {
                                    newNode = {
                                        ...newNode,
                                        name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                        completionCriteria:  nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.completionCriteria
                                    }
                                } else {
                                    newNode = {
                                        ...newNode,
                                        name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                        //selectedForm: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.selectedForm,
                                        formKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey,
                                        completionCriteria:  nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.completionCriteria
                                    }
                                }
                            } else {
                                newNode = {
                                    ...newNode,
                                    name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                    //selectedForm: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.selectedForm,
                                    formKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.key,
                                    completionCriteria:  nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.completionCriteria
                                }
                            }
                        }
                        if (newNode.type === "timer") {
                            if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.selectedForm) {
                                if (nodes[key].data.propertyDetails && !nodes[key].data.propertyDetails.formKey) {
                                    newNode = {
                                        ...newNode,
                                        name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                    }
                                } else {
                                    newNode = {
                                        ...newNode,
                                        name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                        waitTime: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.waitTime || {},
                                        formKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey
                                    }
                                }
                            } else {
                                newNode = {
                                    ...newNode,
                                    name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                    waitTime: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.waitTime || {},
                                    formKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.key
                                }
                            }
                        }
                        if (newNode.type === "condition") {
                            if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.condition) {
                                const values = nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.condition.map((con: any) => {
                                    let nodeId: any
                                    elements.forEach((e: any) => {
                                        if (nodes[key].id === e.source && con.id === e.sourceHandle) {
                                            nodeId = e.target;
                                        }
                                        return nodeId
                                    })
                                    return { name: con.Name, expr: con.expression, nodeId }
                                })
                                const data: any = values && values.map((value: any) => {
                                    const { nodeId, ...others } = value
                                    if (value.nodeId !== undefined && value.nodeId.startsWith("stop")) {
                                        return { ...others, next: { type: "end", nodeId: value.nodeId } }
                                    } else if (value.nodeId !== undefined && value.nodeId.startsWith("subflow")) {
                                        return { ...others, next: { type: "flow", nodeId: value.nodeId } }
                                    } else if (value.nodeId !== undefined && value.nodeId.startsWith("return")) {
                                        return { ...others, next: { type: "return", nodeId: value.nodeId } }
                                    } else if (value.nodeId) {
                                        return { ...others, next: { type: "node", nodeId: value.nodeId } }
                                    } else {
                                        return { ...others, next: { type: "node" } }
                                    }
                                })

                                const payload = data && data.map((el: any) => {
                                    const { expr, ...others } = el
                                    if (expr) {
                                        return { ...el }
                                    } else {
                                        return { ...others }
                                    }
                                })

                                nextNodes.map((n: any) => {
                                    if (n.type === "stop" || n.type === "return") {
                                        if (position[n.id]) {
                                            position[n.id].source = nodes[key].id;
                                        }
                                    }
                                })

                                newNode = {
                                    ...newNode,
                                    name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                    conditions: payload
                                }
                            } else {
                                const values = nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.conditions && nodes[key].data.propertyDetails.conditions.map((con: any) => {
                                    let nodeId: any
                                    elements.forEach((e: any) => {
                                        if (nodes[key].id === e.source && _.camelCase(con.name) === e.sourceHandle) {
                                            nodeId = e.target;
                                        }
                                        return nodeId
                                    })
                                    return { name: con.name, expr: con.expr, nodeId }
                                })

                                const data: any = values && values.map((value: any) => {
                                    const { nodeId, ...others } = value
                                    if (value.nodeId !== undefined && value.nodeId.startsWith("stop")) {
                                        return { ...others, next: { type: "end", nodeId: value.nodeId } }
                                    } else if (value.nodeId !== undefined && value.nodeId.startsWith("subflow")) {
                                        return { ...others, next: { type: "flow", nodeId: value.nodeId } }
                                    } else if (value.nodeId !== undefined && value.nodeId.startsWith("return")) {
                                        return { ...others, next: { type: "return", nodeId: value.nodeId } }
                                    } else if (value.nodeId) {
                                        return { ...others, next: { type: "node", nodeId: value.nodeId } }
                                    } else {
                                        return { ...others, next: { type: "node" } }
                                    }
                                })

                                const payload = data && data.map((el: any) => {
                                    const { expr, ...others } = el
                                    if (expr) {
                                        return { ...el }
                                    } else {
                                        return { ...others }
                                    }
                                })
                                nextNodes.map((n: any) => {
                                    if (n.type === "stop" || n.type === "return") {
                                        if (position[n.id]) {
                                            position[n.id].source = nodes[key].id;
                                        }
                                    }
                                })

                                newNode = {
                                    ...newNode,
                                    name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                    conditions: payload,
                                }
                            }
                        }
                        if (newNode.type === "event") {
                            if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.events) {
                                const values = nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.events.map((con: any) => {
                                    let nodeId: any
                                    elements.forEach((e: any) => {
                                        if (nodes[key].id === e.source && con.id === e.sourceHandle) {
                                            nodeId = e.target;
                                        }
                                        return nodeId
                                    })
                                    return { name: con.Name, handler: con.handler, nodeId }
                                })

                                const data: any = values && values.map((value: any) => {
                                    const { nodeId, ...others } = value
                                    if (value.nodeId !== undefined && value.nodeId.startsWith("stop")) {
                                        return { ...others, next: { type: "end", nodeId: value.nodeId } }
                                    } else if (value.nodeId !== undefined && value.nodeId.startsWith("subflow")) {
                                        return { ...others, next: { type: "flow", nodeId: value.nodeId } }
                                    } else if (value.nodeId !== undefined && value.nodeId.startsWith("return")) {
                                        return { ...others, next: { type: "return", nodeId: value.nodeId } }
                                    } else if (value.nodeId) {
                                        return { ...others, next: { type: "node", nodeId: value.nodeId } }
                                    } else {
                                        return { ...others, next: { type: "node" } }
                                    }
                                })

                                const payload = data && data.map((el: any) => {
                                    const { handler, ...others } = el
                                    if (handler) {
                                        return { ...el }
                                    } else {
                                        return { ...others }
                                    }
                                })

                                nextNodes.map((n: any) => {
                                    if (n.type === "stop" || n.type === "return") {
                                        if (position[n.id]) {
                                            position[n.id].source = nodes[key].id;
                                        }
                                    }
                                })

                                newNode = {
                                    ...newNode,
                                    name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                    eventName: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.eventName || "resume"),
                                    eventHandlers: payload,
                                    componentAcl: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.componentAcl || {})
                                }
                            } else {
                                const values = nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.eventHandler && nodes[key].data.propertyDetails.eventHandler.map((con: any) => {
                                    let nodeId: any
                                    elements.forEach((e: any) => {
                                        if (nodes[key].id === e.source && _.camelCase(con.name) === e.sourceHandle) {
                                            nodeId = e.target;
                                        }
                                        return nodeId
                                    })
                                    return { name: con.name, handler: con.handler, nodeId }
                                })

                                const data: any = values && values.map((value: any) => {
                                    const { nodeId, ...others } = value
                                    if (value.nodeId !== undefined && value.nodeId.startsWith("stop")) {
                                        return { ...others, next: { type: "end", nodeId: value.nodeId } }
                                    }  else if (value.nodeId !== undefined && value.nodeId.startsWith("subflow")) {
                                        return { ...others, next: { type: "flow", nodeId: value.nodeId } }
                                    } else if (value.nodeId !== undefined && value.nodeId.startsWith("return")) {
                                        return { ...others, next: { type: "return", nodeId: value.nodeId } }
                                    } else if (value.nodeId) {
                                        return { ...others, next: { type: "node", nodeId: value.nodeId } }
                                    } else {
                                        return { ...others, next: { type: "node" } }
                                    }
                                })

                                const payload = data && data.map((el: any) => {
                                    const { handler, ...others } = el
                                    if (handler) {
                                        return { ...el }
                                    } else {
                                        return { ...others }
                                    }
                                })
                                nextNodes.map((n: any) => {
                                    if (n.type === "stop" || n.type === "return") {
                                        if (position[n.id]) {
                                            position[n.id].source = nodes[key].id;
                                        }
                                    }
                                })


                                newNode = {
                                    ...newNode,
                                    name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                    eventName: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.eventName || "resume"),
                                    eventHandlers: payload,
                                }
                            }
                        }
                        if(newNode.type === "message") {
                            const details = nodes[key].data.propertyDetails
                            newNode = {
                                ...newNode,
                                name: details.name.length ? details.name : newNode.id,
                                onEnter: (details.onEnter ?? []).map((el: any) => {
                                  const { _id, chosen, selected, ...rest } = el
                                  return rest
                                }),
                                waitForUserMessage: details.waitForUserMessage ?? false,
                            }
                            if(details.waitForUserMessage) {
                                newNode.onReceive = (details.onReceive ?? []).map((el: any) => {
                                  const { _id, chosen, selected, ...rest } = el
                                  return rest
                                })
                            }
                        } else if(newNode.type === "liveAgent") {
                            const details = nodes[key].data.propertyDetails
                            newNode = {
                                ...newNode,
                                name: details.name.length ? details.name : newNode.id,
                            }
                            if(details.params) {
                                newNode.params = Object.keys(details.params).reduce((acc, curr) => {
                                  const val = details.params[curr]
                                  if(val.value?.trim().length) {
                                    acc[curr] = val
                                  }
                                  return acc
                                }, {} as Record<string, any>)
                            }
                        } else if(newNode.type === "subflow") {
                            const details = nodes[key].data.propertyDetails
                            newNode = {
                                ...newNode,
                                name: details.name.length ? details.name : newNode.id,
                                flowName: details.flowName,
                                startNode: details.startNode
                            }
                        }
                        else if (newNode.type === "assistedJourney") {
                            if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.keyValue) {
                                const variables: any = {}
                                nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.keyValue && nodes[key].data.propertyDetails.keyValue.forEach((el: any) => {
                                    const { key, src, id, nameCheck, ...others } = el;
                                    variables[el.key] = {
                                        valueInfo: {},
                                        ...others,
                                    }
                                })
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.processDefinitionKey) {
                                    newNode = {
                                        ...newNode,
                                        name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                        processDefinitionKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.processDefinitionKey,
                                        waitForCompletion: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.completion || false,
                                        outputVariables: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.outputVariables,
                                        inputVariables: variables
                                    }
                                } else {
                                    newNode = {
                                        ...newNode,
                                        name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                        // processDefinitionKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.processDefinitionKey,
                                        waitForCompletion: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.completion || false,
                                        outputVariables: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.outputVariables,
                                        inputVariables: variables
                                    }
                                }
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.webhookHandler.serviceName) {
                                    newNode = {
                                        ...newNode,
                                        webhookHandler: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.webhookHandler
                                    }
                                }
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey) {
                                    newNode = {
                                        ...newNode,
                                        formKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey
                                    }
                                }
                                if (nodes[key].data.propertyDetails.sessionVariables) {
                                    newNode = {
                                        ...newNode,
                                        sessionVariables: nodes[key].data.propertyDetails.sessionVariables
                                    }
                                }
                            } else if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.inputVariables) {
                                newNode = {
                                    ...newNode,
                                    name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                    processDefinitionKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.processDefinitionKey && nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.processDefinitionKey,
                                    waitForCompletion: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.completion || false,
                                    outputVariables: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.outputVariables,
                                    inputVariables: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.inputVariables
                                }
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.webhookHandler.serviceName) {
                                    newNode = {
                                        ...newNode,
                                        webhookHandler: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.webhookHandler
                                    }
                                }
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey) {
                                    newNode = {
                                        ...newNode,
                                        formKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey
                                    }
                                }
                                if (nodes[key].data.propertyDetails.sessionVariables) {
                                    newNode = {
                                        ...newNode,
                                        sessionVariables: nodes[key].data.propertyDetails.sessionVariables
                                    }
                                }
                            }

                        } else if (newNode.type === "webhook") {
                            if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.apiResponseHandler) {
                                newNode = {
                                    ...newNode,
                                    name: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.name || nodes[key].id
                                }
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey) {
                                    newNode = {
                                        ...newNode,
                                        formKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey
                                    }
                                }
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.apiResponseHandler?.serviceName) {
                                    newNode = {
                                        ...newNode,
                                        requestService: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.apiResponseHandler
                                    }
                                }
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.webhookHandler?.serviceName) {
                                    newNode = {
                                        ...newNode,
                                        webhookHandler: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.webhookHandler
                                    }
                                }
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.emailSubject && nodes[key].data.propertyDetails.emailBody) {
                                    newNode = {
                                        ...newNode,
                                        emailNotification: { "subject": nodes[key].data.propertyDetails.emailSubject, "body": nodes[key].data.propertyDetails.emailBody }
                                    }
                                }
                            } else if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.requestService) {
                                newNode = {
                                    ...newNode,
                                    name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                    formKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey,
                                    emailNotification: { "subject": nodes[key].data.propertyDetails.emailSubject, "body": nodes[key].data.propertyDetails.emailBody }
                                }
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.webhookHandler.serviceName) {
                                    newNode = {
                                        ...newNode,
                                        webhookHandler: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.webhookHandler
                                    }
                                }
                                if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.requestService.serviceName) {
                                    newNode = {
                                        ...newNode,
                                        requestService: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.requestService,
                                    }
                                }
                            }

                        } else if (newNode.type === 'action') {
                            const {propertyDetails = {}} = nodes[key]?.data || {}
                            newNode = {
                                ...newNode,
                                integrationName: propertyDetails.integrationName,
                                actionName: propertyDetails.actionName,
                                inputVars: propertyDetails.inputVars, 
                                responseBind: propertyDetails.responseBind,
                                type: "action",
                                name: propertyDetails && (propertyDetails.name || nodes[key].id),
                                ...((propertyDetails && propertyDetails.formKey) && { formKey: propertyDetails.formKey }),
                                ...((propertyDetails && propertyDetails.variableAcl) && { variableAcl: propertyDetails.variableAcl })
                            }
                        }  else if (newNode.type === "aiAgent") {
                            const {propertyDetails = {}} = nodes[key]?.data || {}
                                if (!propertyDetails && propertyDetails.aiAgentKey) {
                                    newNode = {
                                        ...newNode,
                                        name: propertyDetails && (propertyDetails.name || nodes[key].id),
                                    }
                                } else if (propertyDetails?.aiAgentKey) {
                                    newNode = {
                                        ...newNode,
                                        name: propertyDetails && (propertyDetails.name || nodes[key].id),
                                        inputQuery: propertyDetails && propertyDetails.inputQuery || "",
                                        ...((propertyDetails && propertyDetails.formKey) ? { formKey: propertyDetails && propertyDetails.formKey } : {}),
                                        aiAgentKey: propertyDetails.aiAgentKey || agentDetails.key,
                                        inputVars: Array.isArray(propertyDetails?.inputVariable) ? propertyDetails?.inputVariable?.reduce((acc: any, curr: any) => {
                                            acc[curr.key] = curr.value;
                                            return acc;
                                        }, {}) : propertyDetails?.inputVariable,
                                        ...(!propertyDetails?.enableDestructure 
                                            ? { responseBind: propertyDetails?.outputVariable || ""}
                                            : {
                                                responseBind: Array.isArray(propertyDetails?.outputVariable) ? propertyDetails?.outputVariable?.reduce((acc: any, curr: any) => {
                                                    acc[curr.value] = curr.key;
                                                    return acc;
                                                }, {}) : propertyDetails?.outputVariable}) 
                                    }
                                }else {
                                newNode = {
                                    ...newNode,
                                    name: propertyDetails && (propertyDetails.name || nodes[key].id),
                                    inputQuery: propertyDetails && propertyDetails.inputQuery,
                                    ...((propertyDetails && propertyDetails.formKey) ? { formKey: propertyDetails && propertyDetails.formKey } : {}),
                                    aiAgentKey: propertyDetails.aiAgentKey || agentDetails.key ||propertyDetails.agentKey,
                                    inputVars: propertyDetails?.inputVariable,
                                    ...(!propertyDetails?.enableDestructure
                                        ? { responseBind: propertyDetails?.outputVariable }
                                        : {
                                            responseBind: propertyDetails?.outputVariable
                                        }) 
                                }
                            }
                        } else if (newNode.type === "aiClassifier") {
                            if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.classification) {
                                const values = nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.classification.map((con: any) => {
                                    let nodeId: any
                                    elements.forEach((e: any) => {
                                        if (nodes[key].id === e.source && con.id === e.sourceHandle) {
                                            nodeId = e.target;
                                        }
                                        return nodeId
                                    })
                                    return { name: con.name, description: con.description, nodeId }
                                })
                                const data: any = values && values.map((value: any) => {
                                    const { nodeId, ...others } = value
                                    if (value.nodeId !== undefined && value.nodeId.startsWith("stop")) {
                                        return { ...others, next: { type: "end", nodeId: value.nodeId } }
                                    } else if (value.nodeId !== undefined && value.nodeId.startsWith("subflow")) {
                                        return { ...others, next: { type: "flow", nodeId: value.nodeId } }
                                    } else if (value.nodeId !== undefined && value.nodeId.startsWith("return")) {
                                        return { ...others, next: { type: "return", nodeId: value.nodeId } }
                                    } else if (value.nodeId) {
                                        return { ...others, next: { type: "node", nodeId: value.nodeId } }
                                    } else {
                                        return { ...others, next: { type: "node" } }
                                    }
                                })

                                const payload = data && data.map((el: any) => {
                                    const { expr, ...others } = el
                                    if (expr) {
                                        return { ...el }
                                    } else {
                                        return { ...others }
                                    }
                                })

                                nextNodes.map((n: any) => {
                                    if (n.type === "stop" || n.type === "return") {
                                        if (position[n.id]) {
                                            position[n.id].source = nodes[key].id;
                                        }
                                    }
                                })

                                newNode = {
                                    ...newNode,
                                    llm: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.llm,
                                    inputQuery: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.inputQuery || ""),
                                    ...((nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey) ? {formKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey} : {}),
                                    name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                    classifications: payload
                                }
                            } else {
                                const values = nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.classifications && nodes[key].data.propertyDetails.classifications.map((con: any) => {
                                    let nodeId: any
                                    elements.forEach((e: any) => {
                                        if (nodes[key].id === e.source && _.camelCase(con.name) === e.sourceHandle) {
                                            nodeId = e.target;
                                        }
                                        return nodeId
                                    })
                                    return { name: con.name, description: con.description, nodeId }
                                })

                                const data: any = values && values.map((value: any) => {
                                    const { nodeId, ...others } = value
                                    if (value.nodeId !== undefined && value.nodeId.startsWith("stop")) {
                                        return { ...others, next: { type: "end", nodeId: value.nodeId } }
                                    } else if (value.nodeId !== undefined && value.nodeId.startsWith("subflow")) {
                                        return { ...others, next: { type: "flow", nodeId: value.nodeId } }
                                    } else if (value.nodeId !== undefined && value.nodeId.startsWith("return")) {
                                        return { ...others, next: { type: "return", nodeId: value.nodeId } }
                                    } else if (value.nodeId) {
                                        return { ...others, next: { type: "node", nodeId: value.nodeId } }
                                    } else {
                                        return { ...others, next: { type: "node" } }
                                    }
                                })

                                const payload = data && data.map((el: any) => {
                                    const { expr, ...others } = el
                                    if (expr) {
                                        return { ...el }
                                    } else {
                                        return { ...others }
                                    }
                                })
                                nextNodes.map((n: any) => {
                                    if (n.type === "stop" || n.type === "return") {
                                        if (position[n.id]) {
                                            position[n.id].source = nodes[key].id;
                                        }
                                    }
                                })

                                newNode = {
                                    ...newNode,
                                    llm: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.llm,
                                    inputQuery: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.inputQuery || ""),
                                    name: nodes[key].data.propertyDetails && (nodes[key].data.propertyDetails.name || nodes[key].id),
                                    ...((nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey) ? { formKey: nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.formKey } : {}),
                                    classifications: payload,
                                }
                            }
                        }

                        // Set variable acl
                        if (nodes[key].data.propertyDetails && nodes[key].data.propertyDetails.variableAcl) {
                            newNode = {
                                ...newNode,
                                variableAcl: nodes[key].data.propertyDetails.variableAcl
                            }
                        }
                    }

                    if (nodes[key].type.toLowerCase() !== "condition" && nodes[key].type.toLowerCase() !== "event" && nodes[key].type !== "aiClassifier" && nextNodes.length > 0) {
                        if (nextNodes[0].type === "stop") {
                            next.type = "end"
                            if (position[nextNodes[0].id]) {
                                position[nextNodes[0].id].source = nodes[key].id;
                            }
                        } else if (nextNodes[0].type === "return") {
                            next.type = "return"
                            if (position[nextNodes[0].id]) {
                                position[nextNodes[0].id].source = nodes[key].id;
                            }
                        } else {
                            if (nextNodes[0].type === "subflow") {
                                next.type = "flow"
                            } else {
                                next.type = "node"
                            }
                            next['nodeId'] = nextNodes[0].id
                        }
                    }
                    if (!next.nodeId && next.type !== "end" && next.type !== "return") {
                        delete newNode.next;
                    }
                    if (newNode.type !== "stop" && newNode.type !== "return") {
                        payload.source.nodes.push(newNode)
                    }
                }
            }
        }
        let findStopNode: any = [];
        let stopTargetNode: any = [];
        elements.forEach((el: any) => {
            if (el.type === "stop" || el.type === "return") {
                findStopNode.push(el)
            }
        })

        findStopNode.forEach((node: any) => {
            elements.forEach((el: any) => {
                if (el.target === node.id) {
                    stopTargetNode.push(el.source)
                    position[node.id].source = stopTargetNode
                }
            })
            stopTargetNode = [];
        })
        payload.ui.position = position;
        if (payload.source && payload.source.nodes) {
            saveFlowDetails(payload, isCommit, discard)
        }
    }


    const findNextNodes = (nodes: any, edges: any, sourceNode: string) => {
        let nextNodes = [];
        let edgeList = edges.filter((ed: any) => ed.source === sourceNode);
        for (let edge of edgeList) {
            if (edge.target && nodes[edge.target]) {
                nextNodes.push(nodes[edge.target])
            }
        }
        return nextNodes;
    }


    const onEdgeClick = (event: any, edge: any) => {
        setWidgetDrawer(false)
        setEdges((prevState: any) => prevState.map((element: any) => element.id === edge.id ? {
            ...element, animated: true, style: { stroke: "#FF4500", strokeWidth: 3 }
        } : element))
    }

    const onEdgeDoubleClick = (event: any, edge: any) => {
        setWidgetDrawer(false)
        setEdges((prevState: any) => prevState.map((element: any) => element.id === edge.id ? {
            ...element, animated: true, style: { stroke: "#FF4500", strokeWidth: 1.5 }
        } : element))
    }

    const dagreGraph = new dagre.graphlib.Graph();
    dagreGraph.setDefaultEdgeLabel(() => ({}));

    const nodeWidth = 172;
    const nodeHeight = 36;

    const getLayoutedElements = (nodes: any, edges: any, direction = 'TB') => {
        const isHorizontal = direction === 'LR';
        dagreGraph.setGraph({ rankdir: direction });

        nodes.forEach((node: any) => {
            dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
        });

        edges.forEach((edge: any) => {
            dagreGraph.setEdge(edge.source, edge.target);
        });

        dagre.layout(dagreGraph);

        nodes.forEach((node: any) => {
            const nodeWithPosition = dagreGraph.node(node.id);
            node.targetPosition = isHorizontal ? 'left' : 'top';
            node.sourcePosition = isHorizontal ? 'right' : 'bottom';

            // We are shifting the dagre node position (anchor=center center) to the top left
            // so it matches the React Flow node anchor point (top left).
            node.position = {
                x: nodeWithPosition.x - nodeWidth / 2,
                y: nodeWithPosition.y - nodeHeight / 2,
            };

            return node;
        });

        return { nodes, edges };
    };


    const onLayout = useCallback(
        (direction) => {
            const { nodes: layoutedNodes, edges: layoutedEdges } = getLayoutedElements(
                nodes,
                edges,
                direction
            );

            setNodes([...layoutedNodes]);
            setEdges([...layoutedEdges]);
        },
        [nodes, edges]
    );


    const onNodeDoubleClick = (event: any, node: any) => {
        const {type = ""} = node || {}
        if (isCheckedIn) {
        if (node && node.type === "service") {
            setServiceVisible(true)
            setWidgetDrawer(false)
            setSelectedNodeId(node.id)
            dispatch(selectedServices("solo"))
            if (node.data && node.data.propertyDetails && node.data.propertyDetails && node.data.propertyDetails.serviceKey) {
                const services = soloServices && soloServices.filter((form: any) => {
                    return (form.serviceKey === node.data.propertyDetails.serviceKey)
                })
                if (services.length) {
                    setServiceKey(services[0].serviceKey)
                }
            } else {
                setServiceKey(null)
            }
        } else if (node && node.type === "form" || node?.type === "timer") {
            setWidgetDrawer(false)
            setVisible(true)
            setSelectedNodeId(node.id)
            if (node.data && node.data.propertyDetails && node.data.propertyDetails && node.data.propertyDetails.formKey || node && node.data && node.data.propertyDetails && node.data.propertyDetails.key && node.data.propertyDetails.key) {
                const findForms = forms && forms.filter((form: any) => {
                    return (form.formKey === (node.data.propertyDetails.formKey || node.data.propertyDetails.key))
                })
                if (findForms.length) {
                    setFormKey(findForms[0].formKey)
                }
            } else {
                setFormKey(null)
            }
        }

        if (type === "aiAgent") {
            setWidgetDrawer(false)
            setShowAgentModal(true)
            const findAgent = nodes?.filter((el: any) => {return el.id === node.id})
            setAgentDetails({ key: findAgent[0]?.data?.propertyDetails?.aiAgentKey || findAgent[0]?.data?.propertyDetails?.agentKey || "", id: node?.id, inputVariable: [], outputVariable: [], agentSelect: false })
        }
        }
        if (node?.type === "subflow" && node?.data?.propertyDetails?.flowName && soloDetails?.flows) {
            setWidgetDrawer(false)
            const flow = soloDetails.flows.find((f: any) => f.name === node?.data?.propertyDetails?.flowName)
            if (flow) {
                window.open(`#/apps/list/${appId}/journey/solo/list/${flow.id}/create`)
            }
        }
        if (type === "action") {
            setWidgetDrawer(false)
            setShowActionModal(true)
            const findAction = nodes?.filter((el: any) => {return el.id === node.id})
            setActionDetails({ id: node?.id, selectedActionName: `${findAction[0]?.data?.propertyDetails?.actionName || ''}${findAction[0]?.data?.propertyDetails?.integrationName || ''}`})
        }
    }

    const getSavedForm = async (savedFrom: any, select?: string) => {
        dispatch(ModalSelectedValue({
            id: selectedNodeId,
            name: savedFrom && savedFrom[0].form_name,
            key: savedFrom && savedFrom[0].form_key
        }))
        if (savedFrom) {
            const updatedFormNode = nodes.map((el: any) => {
                if (el.id === selectedNodeId) {
                    return {
                        ...el,
                        data: {
                            ...el.data,
                            propertyDetails: {
                                ...el?.data?.propertyDetails,
                                name: (el.data && el.data.propertyDetails && el.data.propertyDetails.name) || (el.id),
                                selectedForm: (savedFrom && savedFrom[0].form_name) || (savedFrom && savedFrom[0].displayName),
                                formKey: (savedFrom && savedFrom[0].form_key) || (savedFrom && savedFrom[0].formKey)
                            }
                        }
                    }
                } else {
                    return el;
                }
            })
            setNodes(updatedFormNode)
        }
        getForms();
        window.open(`#/apps/list/${select === "select" ? savedFrom[0].appId : savedFrom[0].app_id}/solo/forms/list/${select === "select" ? savedFrom[0].formId : savedFrom[0].form_id}/create`)
	localStorage.setItem(`fromSolo:${select === "select" ? savedFrom[0].formId : savedFrom[0].form_id}`, "true")
    }

    const findServiceKeyValues = (params: any, serviceParam: any = {}) => {
        let arr: any = [];
        let keyValue: any = {}
        const keys = Object.keys(params)
        keys && keys.forEach((key: any, id: any) => {
            keyValue = {
                id: key,
                key: key,
                value: serviceParam[key] && serviceParam[key].value || "",
                type: params[key].type || "String",
            }
            if (arr.length > 0) {
                if ((!arr.some((element: any) => element.id === keyValue.id))) {
                    arr.push(keyValue)
                }
            } else {
                arr.push(keyValue)
            }
        })
        return arr;
    }

    const getSoloService = async (res: any, select?: string) => {
        Http.get(`apps/${appId}/solo-services?versionId=${appVersion && appversion.versionId}`).subscribe((resp: any) => {
            setSoloServices(resp.services);
            dispatch(ModalSelectedValue({
                id: selectedNodeId,
                name: res && res.name,
                //key: selFrom && selFrom.serviceKey,
                type: res && res.name !== "" ? "custom" : "",
                serviceKey: res && res.serviceKey,
                select: select
            }))
            if (res) {
                let serviceParams: any;
                let key = resp.services.map((serv: any) => {
                    if (Array.isArray(res)) {
                        if (res[0]?.name === serv.name) {
                            return serv.serviceKey
                        }
                    } else if (typeof (res) === "object") {
                        if (res?.name === serv.name) {
                            return serv.serviceKey
                        }
                    }
                }).filter((e: any) => { return e })
                const updatedServiceNode = nodes.map((el: any) => {
                    if (el.id === selectedNodeId) {
                        let respName = res.length > 0 ? res[0].name : res.name
                        let findType;
                        resp.services && resp.services.forEach((service: any) => {
                            if (service.name === respName) {
                                findType = "custom"
                                const { propertyDetails = {} } = el.data;
                                const { params = {} } = propertyDetails
                                if (service.params) {
                                    serviceParams = findServiceKeyValues(service.params, params)
                                }
                            }
                        })
                        let arr: any = [];
                        const { params = {}, serviceName = "", selectedserviceName = "", serviceKeyValue = [], serviceType = "" } = (el && el.data && el.data.propertyDetails) || {}
                        if (params && findType && (serviceName || selectedserviceName) !== respName) {
                            arr = findServiceKeyValues(params)
                        }
                        let serviceKeyValues = !findType ? (serviceKeyValue || arr) :
                            (_.camelCase(findType) === _.camelCase(serviceType))
                                && arr.length < 1 && respName === (selectedserviceName || serviceName) ?
                                serviceKeyValue :
                                arr ? arr : []
                        return {
                            ...el,
                            data: {
                                ...el.data,
                                propertyDetails: {
                                    ...el?.data?.propertyDetails,
                                    key: el?.data?.propertyDetails?.key,
                                    name: el.data && el.data.propertyDetails && el.data.propertyDetails.name || el.id,
                                    serviceName: res && res.name || res && res[0].name,
                                    selectedserviceName: res && res.name || res && res[0].name,
                                    serviceType: findType || el.data && el.data.propertyDetails && el.data.propertyDetails.serviceType || res && res.id ? "custom" : "",
                                    serviceKey: res && res.serviceKey ? res && res.serviceKey || res && res[0].serviceKey : key[0],
                                    serviceKeyValue: serviceParams ? serviceParams : serviceKeyValues
                                }
                            }
                        }
                    } else {
                        return el;
                    }
                })
                setNodes(updatedServiceNode)
            }
        }, (err: any) => {
            console.error(err)
        })
        window.open(`#/apps/list/${select === "select" ? appId : appId}/solo/service/list/${select === "select" ? res[0].id : res.id}/create`)
        }

    // const KeyLogger = () => {
    //     const spacePressed = useKeyPress('shift');
    //     const cmdAndSPressed = useKeyPress(['shift+s', 'shift+w']);

    //     useEffect(() => {
    //         console.log('space pressed', spacePressed);
    //     }, [spacePressed]);

    //     useEffect(() => {
    //         console.log('cmd and s pressed', cmdAndSPressed);
    //     }, [cmdAndSPressed]);

    //     return null;
    // }

    // const onNodeDrag = (event: any, draggedNode: any, [selectedNodes]: any) => {
    //     // console.log(event, draggedNode, selectedNodes)

    // }

    const onEdgeUpdate = (oldEdge: any, newConnection: any) => {
        setEdges((els: any) => updateEdge(oldEdge, newConnection, els));
    }

    const onEdgeUpdateStart = useCallback(() => {
        edgeUpdateSuccessful.current = false;
    }, []);

    const onEdgeUpdateEnd = useCallback((_, edge) => {
        if (!edgeUpdateSuccessful.current) {
            setEdges((eds: any) => eds.filter((e: any) => e.id !== edge.id));
        }

        edgeUpdateSuccessful.current = true;
    }, []);

    useEffect(() => {
        const contrl:any = document.querySelector(`[title="toggle interactivity"]`)
        if (!isCheckedIn && reactFlowInstance && contrl) {
                contrl.style.pointerEvents = "none";
        }else if(isCheckedIn && canEditSolo && reactFlowInstance && contrl){
            contrl.style.pointerEvents = "all";
        }
    }, [isCheckedIn, reactFlowInstance])

    useEffect(() => {
        if(agentDetails.id && agentDetails.key){
            setNodes(
                nodes.map((el: any) => {
                    if (el.id === agentDetails.id) {
                        // Spread the node and its data
                        const updatedData = {
                            ...el.data,
                            propertyDetails: {
                                ...el.data?.propertyDetails,
                                name: el.data?.propertyDetails?.name || el.id,
                                aiAgentKey: agentDetails.key,
                                selectedAgentOutputVariable: agentDetails.outputVariable,
                                selectedAgentInputVariable: agentDetails.inputVariable,
                                selectedAgent: agentDetails.agentSelect
                            }
                        };
                        // Return updated node with modified data
                        return {
                            ...el,
                            data: updatedData
                        };
                    } else {
                        // Return the node as-is if id doesn't match
                        return el;
                    }
                })
            );
        }
    },[agentDetails])


     useEffect(() => {
        if(actionDetails.function){
            const { function: actionFunc } = actionDetails
            setNodes(
                nodes.map((el: any) => {
                    if (el.id === actionDetails.id) {
                        // Spread the node and its data
                        const isChangedAction = el?.data?.propertyDetails ? `${actionFunc.name}${actionFunc.integration_name}` !== `${el?.data?.propertyDetails.actionName}${el?.data?.propertyDetails.integrationName}` : false;
                        const updatedData = {
                            ...el.data,
                            propertyDetails: {
                                ...el.data?.propertyDetails,
                                integrationName: actionFunc.integration_name,
                                actionName: actionFunc.name,
                                parameters: actionDetails.function?.parameters,
                                name: el.data && (el.data?.propertyDetails?.name || el.id),
                                ...(isChangedAction && ({inputVars: {}}))
                            }
                        };
                        setActionNodeProperties((prev) => ({
                            ...prev,
                            [`${actionFunc.name}:${actionFunc.integration_name}`]: {
                                ...actionDetails,
                                integrationName: actionFunc.integration_name,
                                actionName: actionFunc.name,
                            }
                        }))
                        // Return updated node with modified data
                        return {
                            ...el,
                            data: updatedData
                        };
                    } else {
                        // Return the node as-is if id doesn't match
                        return el;
                    }
                })
            );
        }
    },[actionDetails])

    // const findDeleteKeyCode = osName && osName.includes("Mac") ? "Backspace" : "Delete"
    return (
        <div className={style.solo} >
            <div className="solo_flow" onClick={(e: any) => {
                setOpenIssues(false);
                e.persist();
                if (dragVisible && !e.target.className?.includes("react-flow__renderer")) {
                    setDragVisible(false);
                }
            }}>
                <div style={{ position: "absolute", right: issueDetails ? 60 : 10, marginTop: 30, zIndex: 11 }}>
                    <Button
                        type="primary"
                        disabled={lock}
                        style={{
                            backgroundColor: "#0466C8",
                            display: "flex",
                            alignItems: "center",
                            padding: "0px 10px",
                            color: "#FFF"
                        }} onClick={() => onLayout('LR')}>
                        <img style={{ width: "15px", height: "15px", marginRight: "9px" }} src={layoutIcon} />Format Layout</Button>
                </div>
                <div style={{ width: "100%", height: "100%" }}>
                        <ReactFlow
                            selectedSolo={selectedSolo}
                            issueDetails={issueDetails}
                            isCheckedIn={isCheckedIn}
                            canEdit={canEditSolo}
                            onNodesAndEdgesCreation={(data: any) => {
                              setNodes(data.nodes)
                              setEdges(data.edges)
                              setCheckElementsChanges(data.nodes.concat(data.edges))
                              updateNodesContext('eventNodeServiceConnections', data.eventNodeConnections)
                            }}
                            flowSource={flowDetail}
                            isViewer={false}
                            setLock={(lock: boolean) => {
                            updateNodesContext('lock', lock)
                        }}
                            nodesContext={nodesContext}
                            onNodesChange={onNodesChange}
                            onEdgesChange={onEdgesChange}
                            nodesDraggable={lock === true ? false : true}
                            wrapperRef={reactFlowWrapper}
                            reactFlowRef={reactFlowRef}
                            nodes={nodes}
                            edges={edges}
                            onEdgeDoubleClick={onEdgeDoubleClick}
                            // onNodeDrag={onNodeDrag}
                            onNodeClick={onNodeClick}
                            onEdgeMouseEnter={onEdgeMouseEnter}
                            onEdgeMouseLeave={onEdgeMouseLeave}
                            onNodeMouseEnter={onNodeMouseEnter}
                            onEdgeClick={onEdgeClick}
                            onConnect={onConnect}
                            deleteKeyCode={["Backspace", "Delete"]}
                            multiSelectionKeyCode={['ShiftLeft', 'ShiftRight']}
                            selectionKeyCode={"shift"}
                            onInit={onInit}
                            snapToGrid={true}
                            onNodesDelete={onNodeDelete}
                            onEdgesDelete={onEdgeDelete}
                            onEdgeUpdate={onEdgeUpdate}
                            onEdgeUpdateEnd={onEdgeUpdateEnd}
                            onEdgeUpdateStart={onEdgeUpdateStart}
                            onConnectStart={onConnectStart}
                            onConnectStop={onConnectStop}
                            onDrop={onDrop}
                            onNodeDoubleClick={onNodeDoubleClick}
                            onDragOver={onDragOver}
                            onNodeMouseMove={onNodeMouseMove}
                            onNodeMouseLeave={onNodeMouseLeave}
                            panOnDrag={true}
                            panOnScroll={true}  
                        />
                    </div>
                    {(newNodeDetail || dragVisible) && <WidgetListView
                        showAllNodes={showAllNodes}
                        onAddNewNode={onAddNewNode}
                        onClose={() => {
                            setNewNodeDetail(null);
                            setDragVisible(false);
                        }}
                        newNodeDetail={newNodeDetail}
                        icons={Icons}
                        clearDragVisibile={() => setDragVisible(false)}
                        draggedFrom={draggedFrom}
                        dragVisible={dragVisible}
                        dragCoordinates={dragCoordinates}
                        onDragAddNewNode={onDragAddNewNode}
                    />}
                    {Icons && <WidgetIconsView selectedAuthFlow={flowDetail && flowDetail.authFlow} onSelectedAuthFlow={(authFlow: string) => { setSeletedAuthFlow(authFlow) }} lock={lock} icons={Icons} id={soloId} solo={soloDetails}></WidgetIconsView>}
                    {propertiesDetail && <Properties nodesContext={nodesContext} getFlowDetails={(()=>{getFlowDetails()})} flowDetail={flowDetail} nameCheck={nameCheck} lock={lock} data={propertiesDetail} widgetDrawer={widgetDrawer} soloServices={soloServices} soloBuildinServices={soloBuildInServices} setWidgetDrawer={setWidgetDrawer} forms={forms} flows={soloDetails?.flows} onUpdateProperties={onUpdateProperties} elements={nodes.concat(edges)}></Properties>}
            </div>
             {visible &&
                <FormModal
                    data-test-id="bpmn_saved_form"
                    visible={visible}
                    seletedAppType={"solo"}
                    getSavedForm={getSavedForm}
                    appVersion={appVersion!}
                    selectedFromKey={formkey}
                    soloSelectedNodeId={selectedNodeId}
                    appId={appId}
                    branchId={branchId}
                    setvisible={(status: boolean) => {
                        setVisible(status)

                    }}
                ></FormModal>
            }
            {serviceVisible &&
                <ServiceModal
                    data-test-id="bpmn_srvice"
                    visible={serviceVisible}
                    appVersion={appVersion!}
                    selectedKey={serviceKey}
                    getService={getSoloService}
                    getSoloService={getSoloService}
                    appId={appId}
                    branchId={branchId}
                    soloSelectedNodeId={selectedNodeId}
                    setvisible={(status: boolean) => {
                        setServiceVisible(status)
                    }}
                ></ServiceModal>
            }
            {showAgentModal &&  
                <AgentListModal 
                    setVisible={setShowAgentModal} 
                    setSelectedAgent={setAgentDetails} 
                    selectedAgent={agentDetails}
                    appId={appId}
                    versionId={appVersion && appversion.versionId}
                    branchId={branchId}
                />
            }
            {showActionModal &&
                <ActionModal
                    setVisible={setShowActionModal}
                    setActionDetails={setActionDetails}
                    actionDetails={actionDetails}
                    appId={appId}
                    versionId={appVersion && appversion.versionId}
                    branchId={branchId}
                    visible={showActionModal}
                />
            }
            {issueDetails && (issueDetails.errors || issueDetails.warnings || issueDetails.errorList) &&
                <div className={style.issues} >
                    <div className={style.icon} onClick={() => { setOpenIssues(!openIssues) }} style={{ zIndex: 1, cursor: "pointer" }}>
                        <img style={{ cursor: "pointer" }} alt="issueSvg" src={IssuesSvg} />
                    </div>
                    {openIssues && <div className={style.popup}>
                        <div className={style.items} style={{ height: window.innerHeight - 200 }}>
                            {issueDetails.errors && issueDetails.errors.map((item: any, i: any) => {
                                return <div className={style.card} key={i}>
                                    <div className={style.icon}>
                                        <img alt="issue" src={IssuesSvg} style={{ width: 24, height: 24, marginTop: 3 }} />
                                    </div>
                                    <div>
                                        <div className={style.title}>Error</div>
                                        <div className={style.message}>{item}</div>
                                    </div>
                                </div>
                            })}
                            {issueDetails.errorList && issueDetails.errorList.map((item: any, i: any) => {
                                return <div className={style.card} key={i}>
                                    <div className={style.icon}>
                                        <img alt="issue" src={IssuesSvg} style={{ width: 24, height: 24, marginTop: 3 }} />
                                    </div>
                                    <div>
                                        <div className={style.title}>Error</div>
                                        <div className={style.message}>{item}</div>
                                    </div>
                                </div>
                            })}
                            {issueDetails.warnings && issueDetails.warnings.map((item: any, i: any) => {
                                return <div className={style.card} key={i}>
                                    <div className={style.icon}>
                                        <img alt="warning" src={WarningSvg} style={{ width: 24, height: 24, marginTop: 3 }} />
                                    </div>
                                    <div>
                                        <div className={style.title}>Warning</div>
                                        <div className={style.message}>{item}</div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>}
                </div>}
        </div>
    )
}

export default Solo
